import React from 'react'

const getTitle = (title?: string) => { return (title !== null && typeof(title) !== 'undefined') ? <title>{title}</title> : null }


export type SVGPropType = {
  title?: string
} & React.SVGProps<SVGSVGElement>

export type CustomSVGElement = (props: SVGPropType) => JSX.Element

type SVGItemsType = {
  [propName: string]: CustomSVGElement
}

export const SVGGoogleGLogo = (props: SVGPropType) => (
  <svg
    data-name="Layer 1"
    viewBox="0 0 43 44"
    width="1em"
    height="1em"
    {...props}
  >
    {getTitle(props.title)}
    <path
      d="M9 22a13.06 13.06 0 0 1 .66-4.08l-7.4-5.67a22.18 22.18 0 0 0 0 19.49l7.4-5.67A13 13 0 0 1 9 22z"
      fill="#fbbc05"
    />
    <path
      d="M22 9a12.72 12.72 0 0 1 8.1 2.9l6.4-6.4a22 22 0 0 0-34.24 6.75l7.4 5.67A13 13 0 0 1 22 9z"
      fill="#ea4335"
    />
    <path
      d="M22 35a13 13 0 0 1-12.34-8.92l-7.4 5.67A21.93 21.93 0 0 0 22 44a20.94 20.94 0 0 0 14.33-5.48l-7-5.44A13.62 13.62 0 0 1 22 35zM9.65 26.07l-7.4 5.67 7.4-5.67z"
      fill="#34a853"
    />
    <path
      d="M22 18v8.5h11.8a9.93 9.93 0 0 1-4.49 6.58l7 5.44C40.37 34.76 43 29.17 43 22a18.25 18.25 0 0 0-.5-4z"
      fill="#4285f4"
    />
  </svg>
);

export const SVGAccMinus = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
      d="M4 11h16v2H4z"
    />
  </svg>
);

export const SVGAccPlus = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fillRule="evenodd" clipRule="evenodd" fill="currentColor">
      <path d="M11 4h2v16h-2z" />
      <path d="M4 11h16v2H4z" />
    </g>
  </svg>
);

export const SVGAddToList = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="currentColor">
      <path d="M9.3 12.6h7.2c.4 0 .7-.3.7-.7s-.3-.7-.7-.7H9.3c-.4 0-.7.3-.7.7s.3.7.7.7zM9.3 16.4h1.5c.4 0 .7-.3.7-.7s-.3-.7-.7-.7H9.3c-.4 0-.7.3-.7.7 0 .3.3.7.7.7zM12.9 16.4h.5c.3-.5.6-1 .9-1.4h-1.4c-.4 0-.7.3-.7.7 0 .3.4.7.7.7zM12.6 18.7H9.3c-.4 0-.7.3-.7.7s.3.7.7.7h3.2c-.1-.5 0-.9.1-1.4zM21.4 27.9c-4 0-7.3-3.3-7.3-7.3s3.3-7.3 7.3-7.3 7.3 3.3 7.3 7.3-3.2 7.3-7.3 7.3zm0-13.2c-3.2 0-5.8 2.6-5.8 5.8s2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8-2.6-5.8-5.8-5.8z" />
      <path d="M21.4 24.3c-.4 0-.7-.3-.7-.7v-2.3h-2.3c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h2.3v-2.3c0-.4.3-.7.7-.7s.7.3.7.7v2.3h2.3c.4 0 .7.3.7.7s-.3.7-.7.7h-2.3v2.3c.1.4-.2.7-.7.7zM12.6 22.6H6.4V7.9h2.7v.5c0 .4.3.7.7.7H16c.4 0 .7-.3.7-.7v-.5h2.7v3.8c.5-.1.9-.2 1.4-.2V7.8c0-.7-.6-1.3-1.3-1.3h-2.8V6c0-.4-.3-.7-.7-.7h-1.3C14.5 4.5 13.8 4 13 4s-1.5.5-1.8 1.2H9.9c-.4 0-.8.4-.8.8v.5H6.3c-.7 0-1.3.6-1.3 1.3v14.9c0 .7.6 1.3 1.3 1.3H13c-.1-.5-.3-.9-.4-1.4zm-2-15.9h1.2c.4 0 .7-.3.7-.7 0-.3.2-.5.5-.5s.5.2.5.5c0 .4.3.7.7.7h1.2v1h-4.8z" />
    </g>
  </svg>
);

export const SVGAddedToList = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M12.3 20.6v-.4h-3c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h3.3c.2-.8.5-1.6.8-2.4H13c-.4 0-.7-.3-.7-.7s.3-.7.7-.7h1.4c1.6-2 4-3.3 6.7-3.5V7.9c0-.7-.6-1.3-1.3-1.3H17V6c0-.4-.3-.7-.7-.7H15c-.5-.8-1.2-1.3-2-1.3s-1.5.5-1.8 1.2H9.9c-.4 0-.8.4-.8.8v.5H6.3c-.7 0-1.3.6-1.3 1.3v14.9c0 .7.6 1.3 1.3 1.3H13c-.4-1.1-.7-2.2-.7-3.4zM10.6 6.7h1.2c.4 0 .7-.3.7-.7 0-.3.2-.5.5-.5s.5.2.5.5c0 .4.3.7.7.7h1.2v1h-4.8zm-1.3 4.5h7.2c.4 0 .7.3.7.7s-.3.7-.7.7H9.3c-.4 0-.7-.3-.7-.7s.3-.7.7-.7zm0 3.7h1.5c.4 0 .7.3.7.7s-.3.7-.7.7H9.3c-.4 0-.7-.3-.7-.7 0-.3.3-.7.7-.7z"
      fill="currentColor"
    />
    <path
      d="M21.4 13.1c-4 0-7.4 3.4-7.4 7.5s3.4 7.4 7.4 7.4c4.1 0 7.4-3.3 7.4-7.4s-3.3-7.5-7.4-7.5z"
      fill="#f06f13"
    />
    <path
      d="M20.3 23.6c-.3 0-.6-.1-.8-.3l-1.8-1.6c-.3-.3-.3-.7 0-1s.7-.3.9-.1l1.7 1.5 3.3-4.4c.2-.3.6-.4.9-.1.3.2.3.6.1.9L21.2 23c-.2.4-.5.6-.9.6z"
      fill="#fff"
    />
  </svg>
);

export const SVGArrowBack = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M8.274 15.326l6.082-6.054a.94.94 0 0 1 .667-.273.935.935 0 0 1 .941.937.93.93 0 0 1-.275.664l-4.43 4.409h11.744c.55 0 .997.443.997.991a.995.995 0 0 1-.997.991H11.251l4.438 4.418a.93.93 0 0 1 .275.663.93.93 0 0 1-.275.664.972.972 0 0 1-1.333 0l-6.082-6.053a.925.925 0 0 1-.273-.673.94.94 0 0 1 .273-.684"
      fill="currentColor"
    />
  </svg>
);

export const SVGArrowDown = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path stroke="currentColor" strokeWidth={2} fill="none" d="M19.1 8.5l-7 7-7-7" />
  </svg>
);

export const SVGArrowNext = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M23.7 16.7l-6.1 6.1c-.1.1-.4.2-.6.2s-.5-.1-.7-.3c-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7l4.4-4.4H9c-.5 0-1-.4-1-1 0-.5.4-1 1-1h11.8l-4.4-4.4c-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7.4-.4 1-.4 1.3 0l6.1 6.1c.2.2.3.4.3.7-.1.4-.2.6-.4.8"
      fill="currentColor"
    />
  </svg>
);

export const SVGArrow = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path stroke="currentColor" strokeWidth={2} d="M9 5l7 7-7 7" fill="none" />
  </svg>
);

export const SVGBankCard = (props: SVGPropType) => (
  <svg viewBox="0 0 44 38" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g transform="translate(1 1)" fill="none" fillRule="evenodd">
      <path
        d="M1.949 7.798L33.779.45a2 2 0 0 1 2.398 1.499l4.649 20.137a2 2 0 0 1-1.499 2.398l-31.83 7.349a2 2 0 0 1-2.398-1.5L.449 10.198a2 2 0 0 1 1.5-2.399z"
        stroke="currentColor"
        strokeWidth={2}
        fill="#E6E8F1"
        fillRule="nonzero"
      />
      <rect
        stroke="currentColor"
        strokeWidth={2}
        fill="#FFF"
        fillRule="nonzero"
        x={4.667}
        y={11.333}
        width={36.667}
        height={24.667}
        rx={2}
      />
      <path
        fill="#141B4D"
        fillRule="nonzero"
        d="M5.333 18h35.333v4.667H5.333z"
      />
      <path
        d="M4.667 17.667h36.666M4.667 22.333h36.666"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="square"
      />
    </g>
  </svg>
);

export const SVGBankTransfer = (props: SVGPropType) => (
  <svg viewBox="0 0 27.5 15.5" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g data-name="Layer 2">
      <g
        data-name="Layer 1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="M4.75 4.75v-4h22v14h-22v-3.5M1.75 7.75h7.5m-8.5 3h7.5m-5.5-6h7.5" />
        <ellipse cx={15.75} cy={7.75} rx={3} ry={4} />
        <path d="M21.75 4.75h2M21.75 11.75h2" />
      </g>
    </g>
  </svg>
);

export const SVGBasketIconBlue = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="currentColor"
      d="M24 22.89a2.67 2.67 0 1 0 2.67 2.67A2.68 2.68 0 0 0 24 22.89zm0 3.73a1.07 1.07 0 1 1 1.07-1.06A1.07 1.07 0 0 1 24 26.62zm-8-3.73a2.67 2.67 0 1 0 2.67 2.67A2.68 2.68 0 0 0 16 22.89zm0 3.73a1.07 1.07 0 1 1 1.07-1.06A1.07 1.07 0 0 1 16 26.62zm1.78-9.06a.87.87 0 0 0 .89-.84v-3.66a.89.89 0 0 0-1.78 0v3.66a.87.87 0 0 0 .89.84zm11.82-6.47L11.85 6.53a.85.85 0 0 0-.79.21.81.81 0 0 0-.23.78l2.73 11.93h-1.07L9.23 5.18a.85.85 0 0 0-.65-.63l-5.8-1.2A.83.83 0 0 0 1.8 4a.82.82 0 0 0 .64 1l5.28 1.07L11 20.46a.84.84 0 0 0 .82.65h16.4a.84.84 0 0 0 .83-.72L30.21 12a.82.82 0 0 0-.61-.91zm-2.1 8.36H15.27l-2.51-11 15.7 4zm-2.61-1.89a.89.89 0 0 0 .89-.89v-1.78a.89.89 0 0 0-1.78 0v1.78a.89.89 0 0 0 .89.89zm-3.56 0a.89.89 0 0 0 .89-.88V14a.89.89 0 0 0-1.78 0v2.69a.89.89 0 0 0 .89.87z"
    />
  </svg>
);

export const SVGBasketIcon = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="#141b4d"
      d="M24 30a4.44 4.44 0 0 1-4-2.51 4.44 4.44 0 1 1-7.55-4.6h-.63a2.6 2.6 0 0 1-2.54-2l-3-13.28-4.2-.89a2.61 2.61 0 0 1 .53-5.16 2.32 2.32 0 0 1 .53.05l5.8 1.2a2.61 2.61 0 0 1 2 2 2.46 2.46 0 0 1 .67-.09 2.36 2.36 0 0 1 .65.08L30 9.36a2.63 2.63 0 0 1 2 2.89l-1.17 8.39a2.63 2.63 0 0 1-2.59 2.25h-.67A4.44 4.44 0 0 1 24 30z"
    />
    <path
      fill="#fff"
      d="M24 22.89a2.67 2.67 0 1 0 2.67 2.67A2.68 2.68 0 0 0 24 22.89zm0 3.73a1.07 1.07 0 1 1 1.07-1.06A1.07 1.07 0 0 1 24 26.62zm-8-3.73a2.67 2.67 0 1 0 2.67 2.67A2.68 2.68 0 0 0 16 22.89zm0 3.73a1.07 1.07 0 1 1 1.07-1.06A1.07 1.07 0 0 1 16 26.62zm5.33-9.06a.89.89 0 0 0 .89-.88V14a.89.89 0 0 0-1.78 0v2.69a.89.89 0 0 0 .89.87zm8.27-6.47L11.85 6.53a.85.85 0 0 0-.79.21.81.81 0 0 0-.23.78l2.73 11.93h-1.07L9.23 5.18a.85.85 0 0 0-.65-.63l-5.8-1.2A.83.83 0 0 0 1.8 4a.82.82 0 0 0 .64 1l5.28 1.07L11 20.46a.84.84 0 0 0 .82.65h16.4a.84.84 0 0 0 .83-.72L30.21 12a.82.82 0 0 0-.61-.91zm-2.1 8.36H15.27l-2.51-11 15.7 4zm-2.61-1.89a.89.89 0 0 0 .89-.89v-1.78a.89.89 0 0 0-1.78 0v1.78a.89.89 0 0 0 .89.89zm-7.11 0a.87.87 0 0 0 .89-.84v-3.66a.89.89 0 0 0-1.78 0v3.66a.87.87 0 0 0 .89.84z"
    />
  </svg>
);

export const SVGBfLogo = (props: SVGPropType) => (
  <svg viewBox="0 0 41.97 30" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M31.8 7.106c0-.769-.46-1.112-2.44-1.112-1.57 0-2.56.343-3.1 1.455-.71 1.439-1.1 5.969-1.1 7.146 0 1.815.6 2.142 2.17 2.142 2.69 0 3.78-2.191 4.04-5.069M11.93 9.215c-1.57 0-2.14 1.423-2.31 3.042l-.19 1.684c-.05.393-.09.883-.09 1.063 0 .458.3.638 1.34.638 1.46 0 1.9-.474 2.18-2.469a19.47 19.47 0 0 0 .27-2.748.986.986 0 0 0-1.2-1.21zm29.99 2.8c-.06-.017-2.4-.556-3.8-.883.4-3.729.43-4.432.43-5.021a5.426 5.426 0 0 0-2.5-4.807 10.384 10.384 0 0 0-5.8-1.308h-.05c-3.14 0-6.65.392-9.04 3.237v.017a8.453 8.453 0 0 0-.74 1.112 6.874 6.874 0 0 0-1.28-.082 5.615 5.615 0 0 0-2.27.36c-.11.049-.23.114-.34.163a5.953 5.953 0 0 0-3.13-.752h-.06a3.249 3.249 0 0 0-2.02-2.993A5.4 5.4 0 0 0 9.16.715a5.322 5.322 0 0 0-2.38.425 3.435 3.435 0 0 0-1.94 2.911l-.74 7.031c-1.36.311-3.94.916-4.03.933s-.09.179.5.327c.41.1 2.25.556 3.32.817l-.05.507a19.658 19.658 0 0 0-.15 2.061 4.615 4.615 0 0 0 2.04 3.99 3.055 3.055 0 0 0-.35.588c-.03.082-.06.147-.09.229a4.149 4.149 0 0 0-.2 1.276 2.916 2.916 0 0 0 .46 1.6l-.08.834a3.168 3.168 0 0 0-1.32 2.666 3.02 3.02 0 0 0 2.38 2.959A5.543 5.543 0 0 0 7.7 30a3.8 3.8 0 0 0 3.26-1.651h.19a4.043 4.043 0 0 0 .78-.082 6.38 6.38 0 0 0 1.51.163 5.863 5.863 0 0 0 1.66-.229 3.628 3.628 0 0 0 1.07.148 3.8 3.8 0 0 1 2.69 0 3.7 3.7 0 0 0 .97-.131 6.036 6.036 0 0 0 .69.261c.03.017.08.017.12.033a24.3 24.3 0 0 0 5.32.573h.03c4.44 0 10.44-1.112 11.41-10.646l.54-5.249c1.01-.245 3.09-.752 3.54-.867.54-.132.54-.279.44-.311zM10.1 20.452c-.1 0-.28-.049-.51-.049-.31 0-.38.066-.44.605l-.04.311h.79a.109.109 0 0 1 .12.131 1.738 1.738 0 0 1-.05.376.132.132 0 0 1-.13.082h-.77l-.45 4.137a1.006 1.006 0 0 1-1.1 1.128 3.016 3.016 0 0 1-.54-.065.19.19 0 0 1-.18-.213c0-.212.06-.376.16-.376s.3.033.51.033c.35 0 .41-.066.48-.654l.41-3.99h-.51a.113.113 0 0 1-.12-.131 1.735 1.735 0 0 1 .05-.36.15.15 0 0 1 .13-.082h.5a3.37 3.37 0 0 1 .23-1.1.844.844 0 0 1 .84-.393 2.969 2.969 0 0 1 .59.066c.15.032.2.065.21.163 0 .264-.06.378-.18.378zm1.4 1.047c0 .262-.3 2.616-.3 3.172a6.314 6.314 0 0 0 .08.654c0 .115-.01.213-.32.213-.23 0-.3-.033-.35-.164a3.274 3.274 0 0 1-.1-.654c0-.212.03-.474.1-1.161l.21-2c.02-.2.09-.229.38-.229.25.002.33.019.3.17zm.16-1c-.03.148-.15.164-.41.164s-.34-.049-.34-.213a1.63 1.63 0 0 1 .05-.343c.03-.147.14-.164.41-.164s.34.05.34.2a1.608 1.608 0 0 1-.05.357zm1.71 2.372l.82.327a.876.876 0 0 1 .74.9 1.427 1.427 0 0 1-.44 1.161 2.024 2.024 0 0 1-1.25.327 3.749 3.749 0 0 1-1.02-.131.207.207 0 0 1-.18-.229c0-.261.05-.392.15-.392a5.839 5.839 0 0 0 1.07.163c.65 0 .95-.212.95-.752a.433.433 0 0 0-.33-.458l-.85-.359a.938.938 0 0 1-.71-.933 1.443 1.443 0 0 1 .34-.948 1.5 1.5 0 0 1 1.09-.311 3.85 3.85 0 0 1 1.04.131.206.206 0 0 1 .18.229c0 .36-.09.376-.17.376a7.606 7.606 0 0 0-1.05-.131.826.826 0 0 0-.46.082.616.616 0 0 0-.23.523.425.425 0 0 0 .31.424zm-3.32-4.955c-2.56.032-3.55-.7-3.55-2.191a16.113 16.113 0 0 1 .13-1.766l1.02-9.616c.07-.687.41-.8 1.53-.8 1 0 1.35.082 1.35.621a4.758 4.758 0 0 1-.05.622l-.36 3.385a3.948 3.948 0 0 1 3.3-1.325c1.64 0 2.68.556 2.68 2.764a29.745 29.745 0 0 1-.33 3.646c-.52 3.644-2.09 4.659-5.72 4.659zm8.94 7.391c0 .115-.01.213-.33.213-.24 0-.31-.033-.36-.164a2.683 2.683 0 0 1-.1-.654c0-.474.22-1.979.22-2.387 0-.344-.15-.458-.58-.458-.82 0-1.18.392-1.28 1.357l-.21 2.077c-.02.2-.1.229-.38.229-.25 0-.33-.033-.33-.164 0-.049.02-.131.1-.916l.44-4.268c.02-.2.1-.229.38-.229.25 0 .33.033.33.164 0 .033 0 .114-.12 1.128l-.06.605a1.487 1.487 0 0 1 1.4-.605c.78 0 1.03.295 1.03.867 0 .376-.23 2.011-.23 2.551a6.352 6.352 0 0 0 .08.653zm1.3-16.647l-.56 5.135c-.13 1.21-.21 1.8-.21 2.044 0 .507.08.916.08 1.112 0 .278 0 .769-1.31.769-.88 0-1.17-.1-1.35-.491a3.221 3.221 0 0 1-.18-1.063c0-.213.05-.752.18-1.929l.67-6.427c.07-.638.43-.719 1.51-.719.94 0 1.25.081 1.25.556a5.763 5.763 0 0 1-.08 1.012zM35.28 11l-.76 7.178c-.69 6.885-4.1 8.095-8.57 8.111h-.04a21.932 21.932 0 0 1-4.65-.49.919.919 0 0 1-.74-1.112c0-.8.13-2.143.91-2.143a40.431 40.431 0 0 0 4.5.36h.05c3.55 0 4.32-1.112 4.68-4.677l.05-.457-.06.081c-1.29 1.652-3 2.192-5.23 2.192h-.02c-2.71 0-4.25-.9-4.27-4.383 0-1.651.43-8.454 2.2-10.613 1.38-1.651 3.4-2.224 6.87-2.224h.03c4.06 0 5.46 1.178 5.48 3.32 0 .423-.03 1.028-.43 4.857z"
      fill="#fff"
      fillRule="evenodd"
    />
  </svg>
);

export const SVGBillingAddress = (props: SVGPropType) => (
  <svg viewBox="0 0 19.5 25.5" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          d="M9.75 24.75q9-9.843 9-14.88a9.06 9.06 0 0 0-9-9.12 9.06 9.06 0 0 0-9 9.12q0 5.037 9 14.88z"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <g fill="currentColor">
          <rect x={5.75} y={4.75} width={5} height={1.5} rx={0.5} />
          <rect x={5.75} y={10.75} width={4} height={1.5} rx={0.5} />
          <rect x={8.75} y={7.75} width={5} height={1.5} rx={0.5} />
          <rect x={11.75} y={4.75} width={2} height={1.5} rx={0.5} />
          <rect x={10.75} y={10.75} width={3} height={1.5} rx={0.5} />
          <rect x={5.75} y={7.75} width={2} height={1.5} rx={0.5} />
          <rect x={5.75} y={13.75} width={8} height={1.5} rx={0.5} />
        </g>
      </g>
    </g>
  </svg>
);

export const SVGCancel = (props: SVGPropType) => (
  <svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <circle fill="#FF0F25" stroke="#FF0F25" cx={8} cy={8} r={6} />
    <g fill="none" stroke="#FFF">
      <path d="M5.6 10.5l4.7-5M5.5 5.6l5 4.7" />
    </g>
  </svg>
);

export const SVGCashOnDelivery = (props: SVGPropType) => (
  <svg viewBox="0 0 25.6 18.5" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="#FFF"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="square"
      strokeLinejoin="round"
      d="M19.3 13.7H2.4c-.9 0-1.6-.7-1.6-1.6V2.4c0-.9.7-1.6 1.6-1.6h16.9c.9 0 1.6.7 1.6 1.6V12c0 1-.7 1.7-1.6 1.7z"
    />
    <g fill="currentColor">
      <path d="M3 8h6.9c.3 0 .6.3.6.6s-.3.6-.6.6H3c-.3 0-.6-.2-.6-.6 0-.3.3-.6.6-.6zM3 10.5h4.4c.3 0 .6.3.6.6s-.3.6-.6.6H3c-.3 0-.6-.3-.6-.6 0-.4.3-.6.6-.6zM.8 3.2H21v2.4H.8z" />
    </g>
    <g
      fill="#FFF"
      stroke="currentColor"
      strokeWidth={1.209}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <ellipse cx={19.3} cy={14.5} rx={5.6} ry={2.4} />
      <ellipse cx={19.3} cy={12.1} rx={5.6} ry={2.4} />
      <ellipse cx={19.3} cy={9.7} rx={5.6} ry={2.4} />
    </g>
    <g
      stroke="currentColor"
      strokeWidth={1.209}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <ellipse
        transform="rotate(-45.001 14.257 13.388)"
        fill="#FFF"
        cx={14.3}
        cy={13.4}
        rx={5.6}
        ry={2.4}
      />
      <path
        fill="none"
        d="M9.222 16.317l7.99-7.99 1.132 1.13-7.99 7.991z"
        strokeWidth={1.20898791}
      />
      <ellipse
        transform="rotate(-45.001 13.103 12.32)"
        fill="#FFF"
        cx={13.1}
        cy={12.3}
        rx={5.6}
        ry={2.4}
      />
    </g>
  </svg>
);

export const SVGClock = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M16 6c5.5 0 10 4.5 10 10s-4.5 10-10 10S6 21.5 6 16 10.5 6 16 6zm-.3 3.8v5.8l3.8 4.4"
    />
  </svg>
);

export const SVGClose = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M8 8l15.5 15.5m0-15.5L8 23.5"
    />
  </svg>
);

export const SVGContactActive = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="currentColor">
      <path d="M15.8 16.6l9.4-8.1c-.4-.2-.8-.3-1.2-.3H8c-.5 0-1 .1-1.4.4zM5.6 9.7c-.2.4-.3.8-.3 1.3v10c0 .5.1.9.3 1.3l6.5-6.9zM13.5 22.6c0-1.8.5-3.4 1.4-4.8l-1.7-1.5-6.6 7c.4.3.9.5 1.4.5h5.6c-.1-.4-.1-.8-.1-1.2zM22.3 13.9c1.6 0 3.2.5 4.5 1.2V11c0-.5-.2-1-.4-1.5l-5.2 4.4z" />
    </g>
    <path
      d="M22.3 15.2c-4.1 0-7.4 3.3-7.4 7.4s3.3 7.4 7.4 7.4 7.4-3.3 7.4-7.4-3.3-7.4-7.4-7.4z"
      fill="#f06f13"
    />
    <path
      d="M21.1 25.6c-.3 0-.6-.1-.8-.3l-1.8-1.6c-.3-.2-.3-.7-.1-.9s.7-.3.9-.1l1.7 1.5 3.3-4.4c.2-.3.6-.4.9-.1.3.2.3.6.1.9l-3.4 4.5c-.1.4-.4.5-.8.5z"
      fill="#fff"
    />
  </svg>
);

export const SVGContact = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M8 9h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V11c0-1.1.9-2 2-2zm-1.3.5l8.4 7.3c.5.4 1.3.5 1.8 0l8.4-6.9m-12 5.5l-6.5 7m11.9-7.1l6.7 6.7"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

export const SVGDropPackage = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M15 22h2c1.1 0 2 .9 2 2v1c0 1.1-.9 2-2 2h-2c-1.1 0-2-.9-2-2v-1c0-1.1.9-2 2-2zm10-9c0-5-4-9-9-9s-9 4-9 9l8.3 8.3c.4.4 1 .4 1.4 0L25 13zm-4.5.6c1-3.2.4-6.2-1.5-9m-7.5 9c-1-3.2-.5-6.2 1.5-9m3 8.8v-9M7 13h18"
    />
  </svg>
);

export const SVGEditDisabled = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path d="M24 7.9c-1.1-1.1-2.8-1.1-3.9 0l-11 11-1.3 5.2 5.2-1.3 11-11c1.1-1 1.1-2.8 0-3.9zm-4.6.7l3.9 3.9M9.4 18.6l3.9 3.9M9.1 9.1l13.8 13.8" />
    </g>
  </svg>
);

export const SVGEdit = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M24.199 8.801a2.748 2.748 0 0 0-3.907.027L9.337 19.783 8 25l5.217-1.338 10.955-10.955a2.749 2.749 0 0 0 .027-3.905zM20 10l3.5 3.5M10 20l3.5 3.5"
      stroke="currentColor"
      strokeWidth={1.5}
      fill="none"
    />
  </svg>
);

export const SVGEmptyPreviousOrder = (props: SVGPropType) => (
  <svg viewBox="0 0 80 80" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="currentColor">
      <path d="M63.13 69.13H16a1 1 0 0 1-1-1v-34a.93.93 0 0 1 .11-.44l4.24-8.46a1 1 0 0 1 1.34-.45 1 1 0 0 1 .45 1.34l-3.52 7h27.75a1 1 0 0 1 0 2H17v32.01h45.13V42.35a1 1 0 1 1 2 0v25.78a1 1 0 0 1-1 1zM39.56 50c-4.52 0-8.07-3.23-8.07-7.36a1 1 0 0 1 2 0c0 3 2.67 5.36 6.07 5.36s6.07-2.46 6.07-5.36a1 1 0 0 1 2 0c0 4.03-3.69 7.36-8.07 7.36z" />
      <path d="M38.15 35.2a1 1 0 0 1-.94-.66L34 25.74a1.1 1.1 0 0 1-.11-.32l-.58-1.58-3.55 4.39A1 1 0 1 1 28.18 27l4.31-5.32-1.7-4.68-4.12 5.1a1 1 0 0 1-1.4.15 1 1 0 0 1-.15-1.41l4.83-6-.55-1.5a5.86 5.86 0 0 0-7.21-3.17 5.7 5.7 0 0 0-3.62 7l5.87 16.43a1 1 0 0 1-1.88.68L16.71 17.8a7.7 7.7 0 0 1 4.86-9.53 7.78 7.78 0 0 1 9.72 4.32l4.27 11.65h7.35a1 1 0 0 1 0 2H36.3l2.79 7.61a1 1 0 0 1-.94 1.35zM59.1 18.49a1.06 1.06 0 0 0-1.1 1.07V26a1.06 1.06 0 0 0 1.1 1h6.41a1.07 1.07 0 1 0 0-2.13h-5.34v-5.31a1.07 1.07 0 0 0-1.07-1.07z" />
      <path d="M59.1 13.15a13.55 13.55 0 0 0-9.1 3.62l-2.32-2.31a.8.8 0 0 0-.87-.18.82.82 0 0 0-.5.74V22a.8.8 0 0 0 .8.8H54a.8.8 0 0 0 .57-1.36l-3.1-3.11a11.35 11.35 0 0 1 7.6-3 10.68 10.68 0 1 1 0 21.35 10.57 10.57 0 0 1-7.54-3.13A1.07 1.07 0 0 0 50.05 35a12.81 12.81 0 0 0 21.86-9A12.82 12.82 0 0 0 59.1 13.15z" />
    </g>
  </svg>
);

export const SVGEmptyShoppingList = (props: SVGPropType) => (
  <svg
    data-name="Layer 1"
    viewBox="0 0 80 80"
    width="1em"
    height="1em"
    {...props}
  >
    {getTitle(props.title)}
    <path
      d="M61.32 61.55A17.66 17.66 0 1 1 79 43.89a17.67 17.67 0 0 1-17.68 17.66zm0-33.31A15.66 15.66 0 1 0 77 43.89a15.67 15.67 0 0 0-15.68-15.65z"
      fill="currentColor"
    />
    <rect
      x={56.39}
      y={36.13}
      width={2.03}
      height={6.14}
      rx={1.01}
      fill="currentColor"
    />
    <rect
      x={64.23}
      y={36.13}
      width={2.03}
      height={6.14}
      rx={1.01}
      fill="currentColor"
    />
    <path
      d="M70.18 52.78a1 1 0 0 1-.8-.4 10.07 10.07 0 0 0-16.12 0 1 1 0 0 1-1.6-1.2 12.08 12.08 0 0 1 19.32 0 1 1 0 0 1-.2 1.4 1 1 0 0 1-.6.2z"
      fill="currentColor"
    />
    <path
      d="M65.7 65.22v7.68H15.4V17.3h13v1.8a2.7 2.7 0 0 0 2.7 2.7h19a2.7 2.7 0 0 0 2.7-2.7v-1.8h12.9v5.26a1 1 0 0 0 1 1 1 1 0 0 0 1-1V17.3a2 2 0 0 0-2-2H52.8v-2.2a2.7 2.7 0 0 0-2.7-2.7h-3.6a6.35 6.35 0 0 0-11.8 0h-3.6a2.7 2.7 0 0 0-2.7 2.7v2.2h-13a2 2 0 0 0-2 2v55.6a2 2 0 0 0 2 2h50.3a2 2 0 0 0 2-2v-7.68a1 1 0 0 0-1-1 1 1 0 0 0-1 1zM30.5 13.1a.68.68 0 0 1 .7-.7h4.3a1 1 0 0 0 1-.7 4.36 4.36 0 0 1 8.4 0 1 1 0 0 0 1 .7h4.3a.68.68 0 0 1 .7.7v6a.68.68 0 0 1-.7.7h-19a.68.68 0 0 1-.7-.7z"
      fill="currentColor"
    />
    <path
      d="M41.38 36.06h-21a1 1 0 0 1 0-2h21a1 1 0 0 1 0 2zM32.37 45.61h-12a1 1 0 1 1 0-2h12a1 1 0 0 1 0 2zM26.37 55.17h-6a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2zM38.37 45.61h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 0 2zM42.44 55.17h-12a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2z"
      fill="currentColor"
    />
  </svg>
);

export const SVGError500Img = (props: SVGPropType) => (
  <svg viewBox="0 0 372.86 350.23" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <defs>
      <clipPath id="a">
        <path fill="none" d="M-4.5 17.14h434.81v314.74H-4.5z" />
      </clipPath>
    </defs>
    <path
      d="M126.24 159.81l59.43-11 60.56-.17s13.39 111.42 15.14 131.13l4.57 62.32-39 5-3.47-22.79s-14.18-50.3-16.69-63.19l-13.49-70.64s-3.16-5.13-11.13-5.3L171.71 200l-3.52 14.61L157.75 266l-10.5 43-5.9 34.29h-32.86l2.25-28.84 7.12-75.59z"
      fill="#dcdef1"
    />
    <path
      d="M246.23 136.5s-64-8.6-118.82 11.43l1-20L81.5 185l-13.67-13.27s39.48-56.51 43-85.21L118 10.28h30l192.17-3.19 1.77 12.09s5.35 11 5.43 15.57v22l-30.26 69.63-15.6-5.59s9.81-51.35 10.39-60l-2.49-8.91-30.58-11.31-33.28-1.75z"
      fill="#dcdef1"
      opacity={0.4}
      style={{ isolation: "isolate" }}
    />
    <path
      d="M247.16 129.73l-13.35-41.37s-10.21-29.42-4.58-39.66l17.93-8.53zM136 37.69s-15.14 60.09-28.84 66.45c0 0-28.81 63.2-39.33 67.59L81.5 185l46.86-57z"
      fill="#9198bd"
      opacity={0.2}
      style={{ isolation: "isolate" }}
    />
    <path
      d="M354.59 17.5V332h-298V17.5h298m17-17h-332V349h332z"
      fill="#141b4d"
    />
    <g clipPath="url(#a)">
      <path
        d="M277.29 473.11c-13.83-92.46-14.36-205-26.67-300.58-5.88-45.64-4.65-90.61-4.39-133.8 5.31-1.06 31 1.23 35.84 2.39A131.328 131.328 0 0 1 306 49.5a12.2 12.2 0 0 1 7 9.31 11.541 11.541 0 0 1 .15 2.22c-1.06 20-12 53.52-15.13 62.92 6.37.8 14.58 1.75 21 2.54C328.07 104.64 332.84 89 337 79.35c3.22-7.48 12.07-30.48 12.25-44.69 0-3.61-2.78-8.54-5.88-13.45-4.34-6.85-11-9.71-14.34-11.15 0 0-5.69-2.47-45.39-22.3-20.08-10-18.27-12.25-30.27-16.72A97.59 97.59 0 0 0 212-34.53a39 39 0 0 1-7.17 22.29 27.42 27.42 0 0 1-9.55 8.76c-1.73.92-10.86 5.78-19.91 1.6-5.69-2.63-8.39-7.47-9.56-9.56a25.75 25.75 0 0 1-3.2-13.56c-6.83 2.05-12.49 4-16.73 5.58-8 2.95-10.8 4.37-13.54 6.37a42.765 42.765 0 0 0-8 8c-9.22 12.31-9 37-9.56 52.56-.48 12.54-.94 24.7-4 39-7 32.92-23.45 57.67-31.86 70.08-4.46 6.58-8.45 11.76-11.15 15.13L83 182.88q10.61-11.65 21.5-24.69 12.87-15.45 23.89-30.26m117.84 259.63c-13.29-33.1-22.75-62.14-29.47-85.22-15.89-54.57-14.26-77-20.95-102.32-2.52-9.55-8.49-12.77-12.32-12.87-10.41-.28-14.14 18.62-15.3 27.48-3.12 23.72-28.14 135.37-36.64 186.47h-27.08c3.77-61.88 8.34-112.45 11.94-148.13 5.29-52.42 10.42-91.83 15.93-160.88 2.27-28.4 3-39.36 4-55.2m-10.1 122.92s43.53-9.58 65-11.17h54.95m-118.78-.71s35.82-11 51.7-12.27c20.66-1.66 42.43-3.33 67.12.84m-17.52-85.82c2.39-7.17 17.52-12 17.52-12m-97.7 51.44s19.39-12.74 31.6-12l12.2.8M308.6 51.11s7 5.31 14 4.59"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
      />
      <path
        d="M253.83 279.9c-8.74-8.68-14.74-29.48-9.34-38 23.51-37.22 27.08-83.78 31.31-89.9l9.57-15.12 9.95-4.09.31 9.95a45.352 45.352 0 0 0-7.18 7.86c-4.72 7.32-6.39 15.57-9.4 29.15S282 215 289.33 217.48c8.75 3 19.65 3 19.35-15.13l1-53.21m1.17-12.31c1.63 4.86 6.58 10.51 7 19.68 2.5 56.31 3 56.21 7.1 103.66"
        fill="#fff"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
      />
      <path
        d="M313.53 125.89s-3.16 11.23-3.54 16.39-.76 9.56-1.89 11.37-5.29 2.44-6.23 2.64-2.08-1.49-3 0a2.93 2.93 0 0 1-3.4 1.49 6.83 6.83 0 0 1-3.59-1.49c-.75-.84-5.47-.06-5.29-1.61s.57-3.62 1.89-4.13a4.75 4.75 0 0 0 3.22-4.65c.18-3.1-.39-7-2.27-8-2.74-1.52-7.38 10-8.88 4.73-.89-3.15.76-11.81 2.64-14s6.62-4.46 8.32-4.21 6.31 1.79 7.76-4.29z"
        fill="#fff"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
      />
      <path
        d="M309.64 146.51s-5.54 2.44-8.58 2.63"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
      />
      <path d="M62.69 181.35l-15.03 23.61 6.44 3.86h9.45z" fill="#fff" />
      <path
        d="M68.05 171.87s-12.86 3.51-15.8 8.47 3.3 17.22 4.72 18 6.44-.42 6.13-3l-2-10.11m6.73-.04c3.8.48 11.19 3.32 11.19 3.32 5.82 3.57 25.45 39.87 25.45 39.87L116.41 253l-4.49 47.66s-21.53 13-35.77 17.48c-18.12 5.72-26.23-3.34-46.73-5.72C17 311 16.54 293.84 10.34 290.5 2.78 286.43 3 270.33 4.4 266s23.1-43.73 26-48.38l21.16-29.14 4.23 8.28-10.18 21.15L70.05 254"
        fill="#fff"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
      />
      <path
        d="M78.42 204.77S89.4 228.31 83 244c0 0-10.57 11.1-17.23 12s-21.9-6.23-25-8.9"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
      />
      <path
        d="M70.05 254s-34.72-52.82-43.66-58.25-12.74-4.75-11.71 0 1 13.57 4.82 19.34L39.81 246m-8.52-33s-.6 1.63 6.46-2.09m6.41 8.81s-4.3 5.1-7.5 4.64M52 230.88s-4 3.47-5.78 4.12"
        fill="#fff"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
      />
      <path
        d="M62.92 191.93s6.79-.67 10.84 0M52 206.18c1.79 1.43 12.51 4.68 15.8 4.32l10.59-5.73S77.28 189.2 83 182.88"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
      />
      <path
        d="M321.59 221.63s7.88 48.25 1 52.77c-5.17 3.39-6.76 16.08-6.76 16.08L309.64 280l-8.58 10.52s-8.71.34-11.87-.43c-6.11-1.48-10.36 9-10.36 9s-3.26-16.5-6.77-16.83L261.83 293s-2.74-7.25-3.5-10.31l-5.82 4.41s-5.44-14.18-6.41-19.5"
        fill="#fff"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={4}
      />
    </g>
    <path
      d="M309.4 156.51s.36 27.18-4.06 36.7c-5 10.81-18.67 13.51-26.51 0"
      fill="#fff"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={4}
    />
  </svg>
);

export const SVGExit = (props: SVGPropType) => (
  <svg viewBox="0 0 18.941 15.904" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g data-name="Layer 2">
      <g data-name="Layer 1" fill="currentColor" fillRule="evenodd">
        <path d="M0 0v15.904h12.877v-4.635H11.23v2.963H1.647V1.672h10.949V0H0z" />
        <path d="M18.941 5.854L14.78 1.812l-1.139 1.207 2.23 2.167h-5.863c-2.542 0-4.122 1.846-4.122 4.816h1.647a3.807 3.807 0 0 1 .646-2.351 2.192 2.192 0 0 1 1.829-.793h5.714L13.66 9.052l1.192 1.154 3.684-3.92-.001-.001z" />
      </g>
    </g>
  </svg>
);

export const SVGFalse = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g transform="translate(7 7)" stroke="#C6CADE" strokeWidth={2} fill="none">
      <path d="M16.261 3.256L3.256 16.261" />
      <circle cx={9.5} cy={9.5} r={9.5} />
    </g>
  </svg>
);

export const SVGFilter = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 10.4h8m-15.9 0h2.2M10.3 8.2h2.9v4.3h-2.9zm13 8h.7m-15.9 0h9.4M17.5 14h2.9v4.3h-2.9zM16 22h8M8.1 22h2.2M10.3 19.8h2.9v4.3h-2.9z"
    />
  </svg>
);

export const SVGGrobyLogoBorder = (props: SVGPropType) => (
  <svg viewBox="0 0 68 71" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path fill="#141b4d" d="M63 5v61H5V5h58m5-5H0v71h68V0z" />
    <path
      fill="#18a2dc"
      fillRule="evenodd"
      d="M44.69 26.45a13.24 13.24 0 0 0-8.82-3.34C28.72 23.11 24 27.2 24 35.44c0 5.17 3 11.9 11.83 11.9a12.17 12.17 0 0 0 8-2.64v-5.81h-9v-7h16.31v16.2c-3.28 4.69-8.39 7-15.32 7-14.52 0-20-10.07-20-19.65 0-10.61 6.24-20 20.06-20a18.05 18.05 0 0 1 14 5.82z"
    />
  </svg>
);

export const SVGGrobyLogoSymbol = (props: SVGPropType) => (
  <svg viewBox="0 0 68 71" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path fill="currentColor" d="M63 5v61H5V5h58m5-5H0v71h68V0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M44.69 26.45a13.24 13.24 0 0 0-8.82-3.34C28.72 23.11 24 27.2 24 35.44c0 5.17 3 11.9 11.83 11.9a12.17 12.17 0 0 0 8-2.64v-5.81h-9v-7h16.31v16.2c-3.28 4.69-8.39 7-15.32 7-14.52 0-20-10.07-20-19.65 0-10.61 6.24-20 20.06-20a18.05 18.05 0 0 1 14 5.82z"
    />
  </svg>
);

export const SVGGrobyLogoBlack = (props: SVGPropType) => (
  <svg viewBox="0 0 339 122" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="none">
      <path
        d="M76.7 46.4c-3.9-3.8-9.9-5.7-15-5.7-12.2 0-20.1 7-20.1 21 0 8.8 5 20.2 20.1 20.2 4.5 0 8.6-.7 13.6-4.5v-9.9H60V55.6h27.6v27.5C82 91.1 73.3 95 61.5 95c-24.7 0-34-17.1-34-33.4 0-18 10.6-34 34.1-34 8.8 0 16.6 2.3 23.9 9.9l-8.8 8.9z"
        fill="currentColor"
      />
      <path
        d="M152 50.8c0-11.3-8.2-21.6-23.7-21.6H98v64.1h14.3v-21h10.3l16.4 21h15.8v-1.1L137.2 71c12.2-4.4 14.8-11.8 14.8-20.2zm-23.5 9.4h-16.3V41.5h16.1c6.6 0 9.6 5.3 9.6 9.7 0 4-2.8 9-9.4 9zm27.3 10.6c0 14.5 9.3 24 24.7 24 15.4 0 24.8-9.5 24.8-24 0-13.6-9.7-23.7-24.8-23.7-15 0-24.7 10.1-24.7 23.7zm36.1 0c0 6.4-3.4 12.3-11.4 12.3-8.1 0-11.3-6.1-11.3-12.3 0-5.7 3.6-11.9 11.3-11.9 8 0 11.4 6.2 11.4 11.9zm20.4-41.5v64h11.8l.8-5.8c4.1 5.9 9.2 7.1 15 7.1 13.3 0 22.3-9.9 22.3-24C262.2 56 253 47 239.7 47c-5.4 0-10.2 1.6-14.2 6.5V29.3h-13.2zm25.6 29.8c6.9 0 11.1 4.8 11.1 11.6 0 6.5-4 11.6-11.1 11.6-5.9 0-12.2-3-12.2-11.6 0-7.7 6.1-11.6 12.2-11.6zm44.6 62.8l31.2-73.8h-14.5l-11.1 28.5-11.3-28.5H262l18.9 43.8-8.8 20.7H10V10h319.7v102.6h-33.9l-4 9.3H339V.7H.7v121.2z"
        fill="#141B4D"
      />
    </g>
  </svg>
);

export const SVGGrobyLogoCheckout = (props: SVGPropType) => (
  <svg viewBox="0 0 339 122" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="none">
      <path
        d="M76.7 46.4c-3.9-3.8-9.9-5.7-15-5.7-12.2 0-20.1 7-20.1 21 0 8.8 5 20.2 20.1 20.2 4.5 0 8.6-.7 13.6-4.5v-9.9H60V55.6h27.6v27.5C82 91.1 73.3 95 61.5 95c-24.7 0-34-17.1-34-33.4 0-18 10.6-34 34.1-34 8.8 0 16.6 2.3 23.9 9.9l-8.8 8.9z"
        fill="currentColor"
      />
      <path
        d="M152 50.8c0-11.3-8.2-21.6-23.7-21.6H98v64.1h14.3v-21h10.3l16.4 21h15.8v-1.1L137.2 71c12.2-4.4 14.8-11.8 14.8-20.2zm-23.5 9.4h-16.3V41.5h16.1c6.6 0 9.6 5.3 9.6 9.7 0 4-2.8 9-9.4 9zm27.3 10.6c0 14.5 9.3 24 24.7 24 15.4 0 24.8-9.5 24.8-24 0-13.6-9.7-23.7-24.8-23.7-15 0-24.7 10.1-24.7 23.7zm36.1 0c0 6.4-3.4 12.3-11.4 12.3-8.1 0-11.3-6.1-11.3-12.3 0-5.7 3.6-11.9 11.3-11.9 8 0 11.4 6.2 11.4 11.9zm20.4-41.5v64h11.8l.8-5.8c4.1 5.9 9.2 7.1 15 7.1 13.3 0 22.3-9.9 22.3-24C262.2 56 253 47 239.7 47c-5.4 0-10.2 1.6-14.2 6.5V29.3h-13.2zm25.6 29.8c6.9 0 11.1 4.8 11.1 11.6 0 6.5-4 11.6-11.1 11.6-5.9 0-12.2-3-12.2-11.6 0-7.7 6.1-11.6 12.2-11.6zm44.6 62.8l31.2-73.8h-14.5l-11.1 28.5-11.3-28.5H262l18.9 43.8-8.8 20.7H10V10h319.7v102.6h-33.9l-4 9.3H339V.7H.7v121.2z"
        fill="#fff"
      />
    </g>
  </svg>
);

export const SVGHistory = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M7.4 5.4V10h4.3m4.5 15c4.6 0 7.6-2.9 8.6-7.4s-1.3-8.9-5.5-10.8C15.1 5 10.2 6.3 7.5 9.9m4.4 14.6c.8.4 1 .5 1.9.6m-5.9-2.9c.5.7 1 .8 1.7 1.3m-3.6-5c.2.5.3.8.6 1.3M16 11v5l-4 3"
    />
  </svg>
);

export const SVGIconBasket = (props: SVGPropType) => (
  <svg viewBox="0 0 80 80" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g
      transform="translate(7 13)"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <ellipse cx={34.2} cy={49.6} rx={5.4} ry={5.4} />
      <ellipse cx={53.4} cy={49.6} rx={5.4} ry={5.4} />
      <path d="M37.8 19.3v11.8m8.4-9v8.4m8.4-7.2v7.2M.6.3l15.8 3.4 8.1 34.9h38.4l2.5-19.1L23.9 8.3l6.9 29.6" />
    </g>
  </svg>
);

export const SVGIconDanger = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M1.949 19.362l8.783-15.781a1 1 0 0 1 1.726-.036l9.668 15.781a1 1 0 0 1-.852 1.522H2.823a1 1 0 0 1-.874-1.486zM11.75 7.975v6.12m0 1.905v2.258"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
    />
  </svg>
);

export const SVGIconLink = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M4 5l7 7-7 7m9-14l7 7-7 7"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
    />
  </svg>
);

export const SVGIconSmileHappy = (props: SVGPropType) => (
  <svg viewBox="0 0 80 80" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="currentColor" stroke="currentColor" strokeWidth={2} strokeMiterlimit={10}>
      <path d="M40 76C20.1 76 4 59.9 4 40S20.1 4 40 4s36 16.1 36 36-16.1 36-36 36zm0-70C21.3 6 6 21.3 6 40s15.3 34 34 34 34-15.3 34-34S58.7 6 40 6z" />
      <path d="M40 57.3c-8.1 0-15.6-4.5-19.1-11.4-.3-.5-.1-1.1.4-1.3.5-.3 1.1-.1 1.3.4 3.2 6.3 10 10.4 17.3 10.4s14.1-4 17.3-10.3c.3-.5.9-.7 1.3-.4.5.3.7.9.4 1.3C55.5 52.8 48 57.3 40 57.3zm11.3-25.6c-1.2 0-2-.8-2-2 0-1.1.9-2 2-2s2 .9 2 2c0 1.2-.8 2-2 2zm0-2h0z" />
    </g>
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      d="M26.7 31.7c-1.2 0-2-.8-2-2 0-1.1.9-2 2-2s2 .9 2 2c0 1.2-.8 2-2 2zm0-2h0z"
    />
  </svg>
);

export const SVGIconSmileSad = (props: SVGPropType) => (
  <svg viewBox="0 0 80 80" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="currentColor" stroke="currentColor" strokeWidth={2} strokeMiterlimit={10}>
      <path d="M40 76C20.1 76 4 59.9 4 40S20.1 4 40 4s36 16.1 36 36-16.1 36-36 36zm0-70C21.3 6 6 21.3 6 40s15.3 34 34 34 34-15.3 34-34S58.7 6 40 6z" />
      <path d="M51.3 31.7c-1.2 0-2-.8-2-2 0-1.1.9-2 2-2s2 .9 2 2c0 1.2-.8 2-2 2zm0-2h0s0 0 0 0z" />
    </g>
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      d="M26.7 31.7c-1.2 0-2-.8-2-2 0-1.1.9-2 2-2s2 .9 2 2c0 1.2-.8 2-2 2zm0-2h0s0 0 0 0zM40 44.4c8.1 0 15.6 4.5 19.1 11.4.3.5.1 1.1-.4 1.3-.5.3-1.1.1-1.3-.4-3.2-6.3-10-10.4-17.3-10.4-7.3 0-14.1 4-17.3 10.3-.3.5-.9.7-1.3.4-.5-.3-.7-.9-.4-1.3C24.5 48.9 32 44.4 40 44.4z"
    />
  </svg>
);

export const SVGIconWarningLabel = (props: SVGPropType) => (
  <svg viewBox="0 0 80 80" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g transform="translate(5 5)" fill="none" stroke="currentColor" strokeWidth={2}>
      <g
        transform="translate(7 19)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M37.3 9.3h9.5l6.8 9.2v4.6M9.3 6.6V0h28v27.8H22.9" />
        <ellipse cx={19.8} cy={29.6} rx={3.5} ry={3.5} />
        <ellipse cx={44.2} cy={29.6} rx={3.5} ry={3.5} />
        <path d="M41.2 27.8h-3.9v-9.3h16.3v9.3h-6.4M4.7 13.9H21M0 20.8h16.3M9.3 20.8v7h7.5M7 6.9h16.3" />
      </g>
      <circle cx={35} cy={35} r={35} />
      <path d="M59 10L10 60" />
    </g>
  </svg>
);

export const SVGIllustration404 = (props: SVGPropType) => (
  <svg
    viewBox="0 0 398 347"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="1em"
    height="1em"
    {...props}
  >
    {getTitle(props.title)}
    <defs>
      <path id="a" d="M17 18h396v312H17z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path stroke="#141B4D" strokeWidth={17} d="M8.5 8.5h315v330H8.5z" />
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <g mask="url(#b)">
        <g transform="translate(64 52)">
          <path fill="#DCDEF1" fillRule="nonzero" d="M39 12h135v171H39z" />
          <path
            d="M182 13H64.805c-8.285 0-15 6.716-15 15v155h118.007H0V18C0 8.611 7.611 1 17 1h154.998L182 13z"
            stroke="currentColor"
            strokeWidth={4}
            fill="#E7EAFA"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13 71l147-1-147 1zM13 132l147-1-147 1zM.184 183h157.25"
            stroke="currentColor"
            strokeWidth={4}
            fill="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M147.195 1h31.075"
            stroke="currentColor"
            strokeWidth={5}
            fill="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            fillOpacity={0.407}
            fill="#9198BD"
            x={28}
            y={210}
            width={10}
            height={37}
            rx={2}
          />
          <rect
            stroke="currentColor"
            strokeWidth={4}
            fill="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            x={21}
            y={208}
            width={10}
            height={37}
            rx={2}
          />
          <path
            fillOpacity={0.407}
            fill="#9198BD"
            d="M161.172 183v14l47.627 29v-51z"
          />
          <path
            d="M2 21v.946L49.627 70h109.678V21c0-11.046-8.955-20-20-20H22C10.954 1 2 9.954 2 21zM12 71l44.6 61h102.705V71z"
            fillOpacity={0.128}
            fill="#9198BD"
          />
          <path
            fillOpacity={0.128}
            fill="#9198BD"
            d="M12 131l44.6 52h102.705v-52z"
          />
          <path
            stroke="currentColor"
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M160 183h49v101h-49z"
          />
          <rect
            stroke="currentColor"
            strokeWidth={4}
            strokeLinecap="round"
            strokeLinejoin="round"
            y={1}
            width={160}
            height={306}
            rx={19}
          />
          <path
            d="M179 1h134c10.493 0 19 8.507 19 19v157a6 6 0 0 1-6 6H162a2 2 0 0 1-2-2V20c0-10.493 8.507-19 19-19z"
            stroke="currentColor"
            strokeWidth={4}
            fill="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M332 20v157a6 6 0 0 1-6 6h-8.484a2 2 0 0 1-2-2.011l.89-157.368A24.11 24.11 0 0 0 301 1h12c10.493 0 19 8.507 19 19z"
            stroke="currentColor"
            strokeWidth={4}
            fill="#E7EAFA"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const SVGLink = (props: SVGPropType) => (
  <svg viewBox="0 0 80 80" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="none">
      <path fill="#fff" d="M0 0h80v80H0z" />
      <circle
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        cx={40}
        cy={40}
        r={35}
      />
      <path
        d="M32.856 30.876l-3.818-3.818 3.818 3.818zM29 34.732l-3.837.019L29 34.732zm7.713-7.713l.019-3.837-.019 3.837zm13.324 21.036l3.818 3.818-3.818-3.818zm-3.856 3.856l-.019 3.837.019-3.837zm7.713-7.713l3.837-.019-3.837.019zM38.778 32.472l5.785-5.785c2.667-2.65 6.952-2.672 9.593-.048 2.625 2.64 2.603 6.926-.048 9.593l-6.749 6.749c-1.92 1.909-4.774 2.518-7.279 1.552a6.63 6.63 0 0 1-2.314-1.504m3.325 5.538l-5.785 5.785c-2.666 2.652-6.953 2.674-9.593.048-2.625-2.64-2.603-6.926.048-9.593l5.785-5.785c2.667-2.65 6.952-2.672 9.593-.048"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const SVGListShareAdd = (props: SVGPropType) => (
  <svg viewBox="0 0 30 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M24.532 12.649c.792-1.322 1.268-2.961 1.268-4.743C25.8 3.54 22.98 0 19.5 0s-6.3 3.54-6.3 7.906c0 1.782.476 3.42 1.268 4.743C11.212 14.236 9 17.307 9 20.844v.718C9 22.357 9.627 23 10.4 23h18.2c.773 0 1.4-.644 1.4-1.438v-.718c0-3.537-2.212-6.608-5.468-8.195zM19.5 2.156c2.276 0 4.2 2.633 4.2 5.75s-1.924 5.75-4.2 5.75c-2.276 0-4.2-2.633-4.2-5.75s1.924-5.75 4.2-5.75zm-8.4 18.688c0-2.853 1.953-5.318 4.774-6.478 1.026.908 2.275 1.447 3.626 1.447s2.6-.539 3.626-1.447c2.821 1.16 4.774 3.625 4.774 6.478H11.1zm-4.448-8.192v3.196a1.153 1.153 0 0 1-2.304 0v-3.196H1.152a1.152 1.152 0 0 1 0-2.304h3.196V7.152a1.152 1.152 0 1 1 2.304 0V10.348h3.196a1.152 1.152 0 0 1 0 2.304H6.652z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const SVGListShareAdded = (props: SVGPropType) => (
  <svg
    viewBox="0 0 30 24"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="1em"
    height="1em"
    {...props}
  >
    {getTitle(props.title)}
    <defs>
      <path id="a" d="M0 .979h21v23H0z" />
      <path id="c" d="M.577.7h9.834V21H.577z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2 -.979)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          d="M2.1 21.822c0-2.853 1.953-5.318 4.774-6.479 1.026.91 2.275 1.448 3.626 1.448s2.6-.538 3.626-1.448c2.821 1.161 4.774 3.626 4.774 6.48H2.1zm8.4-18.687c2.276 0 4.2 2.632 4.2 5.75 0 3.116-1.924 5.75-4.2 5.75-2.276 0-4.2-2.634-4.2-5.75 0-3.118 1.924-5.75 4.2-5.75zm5.032 10.492c.792-1.322 1.268-2.96 1.268-4.743 0-4.366-2.82-7.906-6.3-7.906s-6.3 3.54-6.3 7.906c0 1.782.476 3.421 1.268 4.743C2.212 15.214 0 18.285 0 21.822v.72c0 .792.626 1.436 1.4 1.436h18.2c.773 0 1.4-.644 1.4-1.437v-.719c0-3.537-2.212-6.608-5.468-8.195z"
          fill="currentColor"
          mask="url(#b)"
        />
      </g>
      <g transform="translate(19 2.022)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          d="M5.716 11.786c.683-1.197 1.043-2.598 1.043-4.062C6.759 3.851 4.235.7 1.13.7.944.7.759.713.577.735c.348.68.637 1.407.84 2.181 1.769.213 3.215 2.315 3.215 4.808 0 1.586-.59 3.013-1.468 3.904a11.204 11.204 0 0 1 1.47 2.051c2.176 1.05 3.586 3.012 3.648 5.145H6v.717c0 .523-.125 1.015-.333 1.46h3.376c.754 0 1.368-.63 1.368-1.402v-.625c0-2.975-1.795-5.715-4.695-7.188"
          fill="currentColor"
          mask="url(#d)"
        />
      </g>
    </g>
  </svg>
);

export const SVGList = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="currentColor"
      d="M23.4 6h-3.3v-.7c0-.5-.4-.9-.9-.9h-1.5c-.4-.8-1.3-1.4-2.2-1.4s-1.8.6-2.2 1.5h-1.5c-.5 0-.9.4-.9.9V6H7.6C6.7 6 6 6.7 6 7.6v17.8c0 .9.7 1.6 1.6 1.6h15.8c.9 0 1.6-.7 1.6-1.6V7.6c0-.9-.7-1.6-1.6-1.6zm-6.4.2h1.4v1.3h-5.7V6.2H14c.5 0 .9-.4.9-.9 0-.3.3-.6.6-.6s.6.3.6.6c0 .5.4.9.9.9zm-5.2 3h7.4c.5 0 .9-.4.9-.9v-.6h3.3v17.6H7.7V7.7h3.2v.6c0 .5.4.9.9.9z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M10.5 18.8h10.1m-10.1 3.4h10.1m-8.5-9.3l2.2 2.4 4.9-3.9"
    />
  </svg>
);

export const SVGLogin = (props: SVGPropType) => (
  <svg viewBox="0 0 19 20" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="#18A2DC"
      d="M18.8 9.9c0-5.4-4.4-9.9-9.9-9.9-3.6 0-7 2-8.7 5.2-.2.3-.1.8.3.9.3.2.8.1.9-.3 1.5-2.7 4.3-4.5 7.5-4.5 4.7 0 8.5 3.8 8.5 8.5s-3.8 8.5-8.5 8.5c-3.1 0-6-1.7-7.5-4.5-.2-.3-.6-.5-.9-.3s-.5.7-.3 1.1c1.7 3.2 5.1 5.2 8.7 5.2 5.4 0 9.9-4.5 9.9-9.9m-4.2-.7c.1.1.2.3.2.5s-.1.4-.2.5l-4.2 4.3c-.2.3-.7.3-.9 0-.1-.1-.2-.3-.2-.5s.1-.3.2-.5l3.1-3.2H.7c-.4.1-.7-.2-.7-.6S.3 9 .7 9h11.9l-3-3.1c-.2-.2-.3-.4-.3-.5 0-.2.1-.3.2-.5.2-.1.3-.2.5-.2s.3.1.5.2l4.1 4.3"
    />
  </svg>
);

export const SVGLogout = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M16 5.498v9.75m-3-6.237a9 9 0 1 0 6 0"
      stroke="#18A2DC"
      strokeWidth={2}
      fill="none"
    />
  </svg>
);

export const SVGMagnifierGlass = (props: SVGPropType) => (
  <svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M9.808 9.817c.846-.846 1.269-1.862 1.269-3.048s-.421-2.2-1.264-3.043S7.956 2.462 6.77 2.462c-1.186 0-2.2.421-3.043 1.264S2.463 5.583 2.463 6.769c0 1.186.421 2.2 1.264 3.043s1.857 1.264 3.043 1.264c1.186 0 2.199-.42 3.038-1.26zM16 14.769c0 .333-.122.622-.365.865a1.181 1.181 0 0 1-.865.365c-.346 0-.635-.122-.865-.365l-3.298-3.288a6.582 6.582 0 0 1-3.837 1.192 6.65 6.65 0 0 1-2.63-.534 6.768 6.768 0 0 1-2.163-1.442A6.757 6.757 0 0 1 .535 9.399a6.65 6.65 0 0 1-.534-2.63c0-.917.178-1.793.534-2.63a6.768 6.768 0 0 1 1.442-2.163A6.757 6.757 0 0 1 4.14.534 6.65 6.65 0 0 1 6.77 0 6.65 6.65 0 0 1 9.4.534a6.768 6.768 0 0 1 2.163 1.442 6.757 6.757 0 0 1 1.442 2.163 6.65 6.65 0 0 1 .534 2.63c0 1.41-.397 2.689-1.192 3.837l3.298 3.298c.237.237.356.526.356.865z"
      fill="currentColor"
    />
  </svg>
);

export const SVGMinus = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g transform="translate(2 2)" fill="none">
      <rect
        fill="currentColor"
        x={3.767}
        y={9}
        width={12.2}
        height={2.237}
        rx={1.119}
      />
      <circle stroke="currentColor" strokeWidth={2} cx={10} cy={10} r={10} />
    </g>
  </svg>
);

export const SVGMore = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g transform="rotate(-90 15 5)" fill="currentColor">
      <circle cx={2} cy={2} r={2} />
      <circle cx={14} cy={2} r={2} />
      <circle cx={8} cy={2} r={2} />
    </g>
  </svg>
);

export const SVGNavHome = (props: SVGPropType) => (
  <svg
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    {getTitle(props.title)}
    <path
      fill="currentColor"
      d="M23 10.52a1.87 1.87 0 0 0-.67-1.32l-1.9-1.63V2.93a.65.65 0 0 0-.64-.65H17.2a.64.64 0 0 0-.64.65v1.32L13.3 1.47a1.9 1.9 0 0 0-2.51 0L1.68 9.2a1.92 1.92 0 0 0-.21 2.72 2 2 0 0 0 2.12.57v9.86a.64.64 0 0 0 .63.65h15.56a.65.65 0 0 0 .64-.65v-9.86a1.94 1.94 0 0 0 2.11-.57 1.89 1.89 0 0 0 .46-1.4zm-5.16-6.95h1.3v2.89l-1.3-1.11zm-3.21 18.14H9.38v-5.17h5.25zm4.51 0h-3.23v-5.8a.65.65 0 0 0-.64-.65H8.73a.64.64 0 0 0-.63.65v5.8H4.87V11.56L12 5.47l7.1 6.08zm2.41-10.63a.63.63 0 0 1-.9.07l-8.19-7a.63.63 0 0 0-.83 0l-8.28 7a.64.64 0 1 1-.84-1l9.11-7.73a.64.64 0 0 1 .84 0l9 7.73a.64.64 0 0 1 .07.91zM13.51 9h-3a.48.48 0 0 0-.48.5v3a.48.48 0 0 0 .48.5h3a.49.49 0 0 0 .49-.5v-3a.49.49 0 0 0-.49-.5zM13 12h-2v-2h2z"
    />
    <circle fill="currentColor" cx={12.5} cy={18.5} r={1} />
  </svg>
);

export const SVGNavIcon = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M3 7h26M3 16h26M3 25h26"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
    />
  </svg>
);

export const SVGNavSearch = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M18.384 18.395c.982-.982 1.473-2.161 1.473-3.538 0-1.376-.489-2.554-1.468-3.532-.978-.978-2.156-1.468-3.532-1.468s-2.554.489-3.532 1.468c-.978.978-1.468 2.156-1.468 3.532s.489 2.554 1.468 3.532c.978.978 2.156 1.468 3.532 1.468s2.552-.487 3.527-1.462zm7.188 5.748c0 .387-.141.722-.424 1.004a1.373 1.373 0 0 1-1.004.424c-.402 0-.737-.141-1.004-.424l-3.828-3.817a7.64 7.64 0 0 1-4.453 1.384 7.717 7.717 0 0 1-3.052-.619 7.856 7.856 0 0 1-2.511-1.674 7.856 7.856 0 0 1-1.674-2.511c-.413-.971-.619-1.988-.619-3.052s.206-2.081.619-3.052a7.856 7.856 0 0 1 1.674-2.511 7.856 7.856 0 0 1 2.511-1.674c.971-.413 1.988-.619 3.052-.619s2.081.206 3.052.619a7.856 7.856 0 0 1 2.511 1.674 7.856 7.856 0 0 1 1.674 2.511c.413.971.619 1.988.619 3.052a7.64 7.64 0 0 1-1.384 4.453l3.828 3.828c.275.275.413.61.413 1.004z"
      fill="currentColor"
    />
  </svg>
);

export const SVGNavicon1 = (props: SVGPropType) => (
  <svg
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    {getTitle(props.title)}
    <path
      d="M16.73 3.1a.93.93 0 0 1 .41 1.26L8.47 21.41a1 1 0 0 1-.83.52.87.87 0 0 1-.42-.1.94.94 0 0 1-.47-.55.92.92 0 0 1 0-.71l8.73-17.06a.94.94 0 0 1 .52-.46 1 1 0 0 1 .29 0 .9.9 0 0 1 .44.05zM6.19 4.32A4.19 4.19 0 1 1 2 8.51a4.2 4.2 0 0 1 4.19-4.19zm0 6.52a2.33 2.33 0 1 0-2.32-2.33 2.33 2.33 0 0 0 2.32 2.33zm11.62 1.39a4.19 4.19 0 1 1-4.19 4.19 4.2 4.2 0 0 1 4.19-4.19zm0 6.51a2.33 2.33 0 1 0-2.32-2.32 2.33 2.33 0 0 0 2.32 2.32z"
      fill="currentColor"
    />
  </svg>
);

export const SVGNavicon2 = (props: SVGPropType) => (
  <svg
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    {getTitle(props.title)}
    <path
      d="M21.84 10a3.06 3.06 0 0 0-2.31-1 2.87 2.87 0 0 0-1.53.43V5.81a1.34 1.34 0 0 0-1.35-1.33h-2.81V4a.72.72 0 0 0-.73-.71h-1.28A2 2 0 0 0 10 2a2 2 0 0 0-1.84 1.24H6.87a.71.71 0 0 0-.72.76v.53h-2.8A1.34 1.34 0 0 0 2 5.81v14.86A1.34 1.34 0 0 0 3.35 22h13.3A1.34 1.34 0 0 0 18 20.67v-2.18l.57-.49a26.34 26.34 0 0 0 2.94-2.73 4.32 4.32 0 0 0 1.2-2.85 3.62 3.62 0 0 0-.87-2.42zM7.59 4.67h1.15A.73.73 0 0 0 9.47 4a.52.52 0 0 1 .53-.57.53.53 0 0 1 .53.52.72.72 0 0 0 .72.72h1.15v1H7.59zm9 15.9H3.44V5.91h2.71v.52a.72.72 0 0 0 .72.72h6.24a.73.73 0 0 0 .73-.72v-.52h2.74v4.31A3 3 0 0 0 14.18 9a3.06 3.06 0 0 0-2.31 1 3.71 3.71 0 0 0-.59 1L11 12a3 3 0 0 0 0 .42 4.32 4.32 0 0 0 1.2 2.85A26.34 26.34 0 0 0 15.14 18l1.38 1.18zm1.24-3.65l-1 .83c-.33-.29-.66-.56-1-.83-2.05-1.73-3.4-2.87-3.4-4.33a2.35 2.35 0 0 1 .62-1.59 1.84 1.84 0 0 1 2.95.24 3.42 3.42 0 0 1 .44.86.44.44 0 0 0 .83 0 3.42 3.42 0 0 1 .44-.86 1.87 1.87 0 0 1 1.54-.87 1.89 1.89 0 0 1 1.41.63 2.35 2.35 0 0 1 .56 1.56c0 1.49-1.35 2.63-3.4 4.36z"
      fill="currentColor"
    />
    <path
      d="M6.6 12.3H11m-4.4 4.2h4.78"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);

export const SVGNavicon3 = (props: SVGPropType) => (
  <svg
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.82 8.51H20l3 3.73v1.86"
    />
    <circle
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      cx={7.84}
      cy={18.09}
      r={1.6}
    />
    <circle
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      cx={19.01}
      cy={18.09}
      r={1.6}
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.54 16.49h-.72V13.3H23v3.19h-6.46zM2.6 11.07h6.78M1 13.47h6.78"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.85 14.1v2.39h12v-12h-12v3.22l-.06 1h7.39"
    />
  </svg>
);

export const SVGNewCard = (props: SVGPropType) => (
  <svg viewBox="0 0 23.16 19.63" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          d="M2.91 13.38h8.25a.59.59 0 0 1 0 1.17H2.91a.59.59 0 0 1 0-1.17zm0 2.35h4.32a.59.59 0 0 1 0 1.18H2.91a.59.59 0 0 1 0-1.18zM.75 8.66h12.3L15.72 11H.75z"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          d="M12.54 6.3H2.32A1.57 1.57 0 0 0 .75 7.88v9.42a1.57 1.57 0 0 0 1.57 1.58h16.5a1.57 1.57 0 0 0 1.57-1.58v-6.91"
          fill="none"
          stroke="currentColor"
          strokeLinecap="square"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <path
          d="M17.16 0a6 6 0 1 1-6 6 6 6 0 0 1 6-6zm1 5V3h-2v2h-2v2h2v2h2V7h2V5z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </g>
  </svg>
);

export const SVGNew = (props: SVGPropType) => (
  <svg viewBox="0 0 40 40" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="none">
      <path
        fill="currentColor"
        d="M40 20l-2.735-4.627.058-5.376-4.687-2.633-2.633-4.687-5.376.058L20 0l-4.627 2.735-5.376-.058-2.633 4.687-4.687 2.633.058 5.376L0 20l2.735 4.627-.058 5.376 4.686 2.633 2.634 4.687 5.376-.058L20 40l4.627-2.735 5.376.058 2.633-4.686 4.687-2.634-.058-5.376z"
      />
      <g fill="#77D6FA">
        <path d="M25.751 8.72A12.524 12.524 0 0 0 20 7.342c-2.025 0-3.96.464-5.752 1.38a12.771 12.771 0 0 0-4.375 3.683l1.878 1.41A10.233 10.233 0 0 1 20 9.69c3.273 0 6.28 1.504 8.249 4.125l1.878-1.411a12.772 12.772 0 0 0-4.376-3.683zM28.249 26.185A10.233 10.233 0 0 1 20 30.31c-3.273 0-6.28-1.504-8.249-4.125l-1.878 1.411a12.772 12.772 0 0 0 4.375 3.683A12.524 12.524 0 0 0 20 32.66c2.025 0 3.96-.464 5.752-1.38a12.773 12.773 0 0 0 4.375-3.683l-1.878-1.41z" />
      </g>
      <path
        d="M15.235 21.247c0 .552.163.996.49 1.33.326.335.74.502 1.242.502.493 0 .893-.165 1.198-.495.305-.33.458-.776.458-1.337v-5.17h2.297v5.17c0 .762-.161 1.429-.484 2.002a3.27 3.27 0 0 1-1.38 1.324c-.598.31-1.299.464-2.102.464-.803 0-1.508-.155-2.114-.464a3.332 3.332 0 0 1-1.406-1.324c-.33-.573-.496-1.24-.496-2.002v-5.17h2.297v5.17zm2.083-7.943l1.845.702-1.82 1.444-1.53-.126 1.505-2.02zm10.487 8.709c0 .937-.274 1.665-.822 2.183-.548.519-1.295.778-2.24.778-1.23 0-2.25-.472-3.062-1.418l1.054-1.568c.31.318.627.562.954.734.326.171.623.257.89.257.285 0 .509-.088.672-.263.163-.176.245-.427.245-.753v-3.991h-3.012v-1.895h5.32v5.936z"
        fill="#FFF"
      />
      <path
        d="M40 20l-2.735 4.627.058 5.376-4.687 2.634-2.633 4.686-5.376-.058L20 40l-4.627-2.735-5.376.058-2.634-4.687-4.686-2.633.058-5.376L0 20l2.735-4.627-.058-5.376 4.687-2.633 2.633-4.687 5.376.058L20 0l4.627 2.735 5.376-.058 2.633 4.687 4.687 2.633-.058 5.376L40 20zm-9.089 10.911l4.048-2.274-.05-4.64L37.271 20l-2.361-3.996.05-4.64-4.049-2.275-2.274-4.048-4.64.05L20 2.728 16.004 5.09l-4.64-.05L9.088 9.09 5.04 11.363l.05 4.64L2.728 20l2.361 3.996-.05 4.64 4.049 2.275 2.274 4.048 4.64-.05L20 37.272l3.996-2.361 4.64.05 2.275-4.049z"
        fill="#141B4D"
      />
    </g>
  </svg>
);

export const SVGOk = (props: SVGPropType) => (
  <svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <circle fill="#18A2DC" stroke="#18A2DC" cx={8} cy={8} r={6} />
    <path fill="none" stroke="#FFF" d="M5.1 8.3l1.8 1.6 3.7-4" />
  </svg>
);

export const SVGOkoslista = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M13.3 25.7h-.7l-.9-.1-3.4-.9c-.8-.2-1.4-1-1.4-1.8L7 7.6c0-.2.2-.3.4-.2l1.8 1.2c.1.1.2 0 .3 0l1.3-1.4c0-.2.1-.2.2-.1l1.9 1.5 2-1.6c.1 0 .2 0 .3.1l1.6 1.3c.1.1.2.1.3 0l1.5-1.2c.1-.1.2-.1.3 0l1.4 1.2c.1.1.2.1.3 0L22 7.1c.1-.1.3-.1.3 0l1.4 1.5c.1.1.2.1.3 0l2-1.1c.2-.1.4 0 .4.2l-.1 15c0 .7-.4 1.2-1 1.3l-12 1.7H13l-.1-17m3.1 7.1l2.3 2.5 5-4.4"
    />
  </svg>
);

export const SVGPackage = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M15.2 21.7H4.5V9.1l3.6-5.4h10.8l3.6 5.4v5.3M4.6 8.9h17.8m-8.9-5.2v5.2"
    />
    <circle
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      cx={21.5}
      cy={21.7}
      r={7}
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M18.5 21.5l3-3 3 3m-3-2.8v7"
    />
  </svg>
);

export const SVGPaperPlane = (props: SVGPropType) => (
  <svg viewBox="0 0 55 55" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="none" fillRule="evenodd">
      <path fill="#E6E8F1" d="M52.741 3L30 36.56 54 44z" />
      <path
        fill="#BCBFD3"
        d="M49 7L23 33.693 29.911 46l8.064-7.151-8.064-2.412z"
      />
      <path fill="#FFF" d="M52 2L7 28.736 23.113 34z" />
      <g fill="currentColor" fillRule="nonzero">
        <path d="M54.46.142a1.062 1.062 0 0 0-1.074.008L33.78 11.837a1.083 1.083 0 0 0-.377 1.477c.301.513.957.683 1.466.38l14.067-8.385-26.202 27.406-13.032-4.02L26.71 18.558c.509-.304.677-.965.377-1.478a1.065 1.065 0 0 0-1.466-.38L6.525 28.084a1.081 1.081 0 0 0 .232 1.96l15.563 4.8 6.866 12.598a.256.256 0 0 0 .022.034 1.069 1.069 0 0 0 .916.525c.274 0 .544-.106.748-.307l7.895-7.778 14.85 4.58a1.064 1.064 0 0 0 .95-.165c.272-.203.433-.525.433-.867V1.08a1.08 1.08 0 0 0-.54-.937zM28.938 34.86c-.125.178-.192.39-.192.608V42L24 33.483 45 12 28.938 34.86zM31 45v-7l5 1.669L31 45zm22-3l-21-6.47L53 5v37z" />
        <path d="M17.69 37.31a1.059 1.059 0 0 0-1.497 0L6.31 47.193a1.059 1.059 0 0 0 1.497 1.497l9.883-9.883a1.059 1.059 0 0 0 0-1.497zM4.66 50.34a1.163 1.163 0 0 0-1.645 0L.341 53.015a1.163 1.163 0 0 0 1.644 1.644l2.674-2.674a1.163 1.163 0 0 0 0-1.645zM15.707 53.293A1.007 1.007 0 0 0 15 53c-.264 0-.521.107-.707.293A1.006 1.006 0 0 0 14 54c0 .263.107.521.293.707.186.186.444.293.707.293.263 0 .521-.107.707-.293.186-.186.293-.444.293-.707 0-.264-.107-.521-.293-.707zM23.663 45.337a1.152 1.152 0 0 0-1.63 0l-5.696 5.696a1.152 1.152 0 0 0 1.63 1.63l5.696-5.696c.45-.45.45-1.18 0-1.63zM41.663 44.337a1.15 1.15 0 0 0-1.626 0l-5.7 5.7a1.15 1.15 0 0 0 1.626 1.626l5.7-5.7a1.15 1.15 0 0 0 0-1.626zM30.707 14.293A1.008 1.008 0 0 0 30 14c-.263 0-.521.107-.707.293a1.009 1.009 0 0 0-.293.708 1.003 1.003 0 0 0 1.707.706c.186-.186.293-.443.293-.706 0-.264-.107-.522-.293-.708z" />
      </g>
    </g>
  </svg>
);

export const SVGPercent = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M21.424 6.106c.48.244.676.838.431 1.319l-9.084 17.858a.975.975 0 0 1-1.799-.139.962.962 0 0 1 .057-.749l9.084-17.858A.99.99 0 0 1 20.984 6a.95.95 0 0 1 .44.106zM10.387 7.384c2.417 0 4.387 1.97 4.387 4.387s-1.97 4.387-4.387 4.387S6 14.188 6 11.771s1.97-4.387 4.387-4.387zm0 6.821a2.436 2.436 0 0 0 2.434-2.434 2.436 2.436 0 0 0-2.434-2.434 2.436 2.436 0 0 0-2.434 2.434 2.436 2.436 0 0 0 2.434 2.434zm12.169 1.457c2.417 0 4.387 1.97 4.387 4.387s-1.97 4.387-4.387 4.387-4.387-1.97-4.387-4.387 1.97-4.387 4.387-4.387zm0 6.821a2.436 2.436 0 0 0 2.434-2.434 2.436 2.436 0 0 0-2.434-2.434 2.436 2.436 0 0 0-2.434 2.434 2.436 2.436 0 0 0 2.434 2.434z"
      fill="currentColor"
    />
  </svg>
);

export const SVGPhoneReceiver = (props: SVGPropType) => (
  <svg viewBox="0 0 10 10" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M9.995 7.892a.485.485 0 0 1-.148.424L8.439 9.714a.78.78 0 0 1-.249.18 1.033 1.033 0 0 1-.302.095l-.064.005-.138.005c-.134 0-.351-.023-.651-.069-.3-.046-.667-.159-1.101-.339-.434-.18-.926-.45-1.477-.81-.55-.36-1.136-.855-1.757-1.483A11.608 11.608 0 0 1 1.472 5.9a9.836 9.836 0 0 1-.783-1.234 6.614 6.614 0 0 1-.445-1.028 5.394 5.394 0 0 1-.201-.794 2.642 2.642 0 0 1-.042-.524l.011-.212c.014-.099.046-.2.095-.302a.79.79 0 0 1 .18-.249L1.695.148A.466.466 0 0 1 2.034 0c.092 0 .173.026.243.079a.719.719 0 0 1 .18.196l1.133 2.15a.515.515 0 0 1 .053.371.658.658 0 0 1-.18.339l-.519.519-.037.069-.016.079c.028.148.092.318.191.508.085.169.215.376.392.62.176.244.427.524.752.842.318.325.6.577.847.757.247.18.453.312.619.397.166.085.293.136.381.154l.132.027.069-.016.069-.037.603-.614a.647.647 0 0 1 .445-.169c.12 0 .215.021.286.064h.011l2.043 1.208a.536.536 0 0 1 .265.35z"
      fill="currentColor"
    />
  </svg>
);

export const SVGPinGrey = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g transform="translate(8 4)" fill="none" stroke="currentColor" strokeWidth={2}>
      <path d="M4.2-1.8c-1.8 0-3.5.7-4.8 2s-2 3-2 4.8c0 6.1 6.8 12.3 6.8 12.3S11 11.1 11 5c0-1.8-.7-3.5-2-4.8-1.3-1.3-3-2-4.8-2z" />
      <ellipse cx={4.2} cy={5} rx={3.5} ry={3.5} />
    </g>
  </svg>
);

export const SVGPlusOrange = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M11 11V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5z"
      fill="#FF7716"
    />
  </svg>
);

export const SVGPlusLarge = (props: SVGPropType) => (
  <svg viewBox="0 0 42 42" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="none">
      <circle stroke="currentColor" strokeWidth={2} cx={21} cy={21} r={20} />
      <path
        d="M22.497 22.497v7.007a1.497 1.497 0 0 1-2.994 0v-7.007h-7.007a1.497 1.497 0 1 1 0-2.994h7.007v-7.007a1.497 1.497 0 1 1 2.994 0v7.006h7.007a1.497 1.497 0 0 1 0 2.994h-7.007z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const SVGPlus = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g transform="translate(2 2)" fill="none">
      <circle cx={10} cy={10} r={10} />
      <circle stroke="currentColor" strokeWidth={2} cx={10} cy={10} r={10} />
      <path
        d="M9 9.188V6.375a1 1 0 0 1 2 0v2.813h3a1 1 0 0 1 0 2h-3v3.188a1 1 0 0 1-2 0v-3.188H6a1 1 0 0 1 0-2h3z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const SVGPreviousOrder = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M22 17.7V27H5V12h11m-5 2.7V8.8C11 6.7 12.6 5 14.6 5c1.2 0 2.3.7 3 1.7l.4.7"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M22 6c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6zm0 2.3V12l2.5 2.7"
    />
  </svg>
);

export const SVGProdAlapvetoelelmiszer = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7 14.6h20V29H7V14.6zM25.2 11l1.8 3.6H7L8.8 11M20 18.2c0 1.5-1.4 2.7-3 2.7-1.7 0-3-1.2-3-2.7"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22.5 14.6l1.5-3c.5-.7.3-1.6-.3-2.2-.6-.6-1.3-1-2.1-1.2-.7-.3-1.5-.4-2.3-.4-.8.2-1.3.9-1.3 1.7 0 0-.4 2.1-.2 5.1m3.8-6.4l.6-2.4m.5 2.8l1.9-1.5m-4.1.8l-.9-2.5M18 9.5l2.6.9m-.2 2.5l2.4.8"
    />
    <path fill="none" d="M2 1h23v13H2V1z" />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.2 14.5l-2.5-7c-.4-1.4.3-3 1.8-3.5 1.4-.5 3 .2 3.6 1.6l3.3 9M12.9 7.1l-1.7 2.1m3 .5l-1.7 2.1m5.4-1H15"
    />
  </svg>
);

export const SVGProdAlcoholicDrinks = (props: SVGPropType) => (
  <svg
    data-name="Layer 1"
    viewBox="0 0 34 34"
    width="1em"
    height="1em"
    {...props}
  >
    {getTitle(props.title)}
    <path
      d="M27.19 30a.29.29 0 0 1-.12.22c-.43.39-2.05.69-4 .69s-3.56-.3-4-.69A.29.29 0 0 1 19 30c0-.15.17-.29.46-.41a10.56 10.56 0 0 1 3.65-.49 10.56 10.56 0 0 1 3.65.49c.24.07.43.21.43.41zM23.09 23.8v5.25M15.6 17.06v12.72h0a.31.31 0 0 1-.13.22c-.48.39-2.27.69-4.4.69s-3.93-.3-4.41-.69a.31.31 0 0 1-.13-.22V17.06a5.64 5.64 0 0 1 1.37-3.68l.87-1a4.84 4.84 0 0 0 .8-2.67v-6.2c0-.07.06-.12.17-.17a3.74 3.74 0 0 1 1.33-.2 3.7 3.7 0 0 1 1.33.2c.11.05.17.1.17.17v6.2a4.85 4.85 0 0 0 .81 2.67l.87 1a5.64 5.64 0 0 1 1.35 3.68zM9.55 8.22h3"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M15.6 17.51h-6v6.77h6zM27.49 17.37c0 3.2-2 5.79-4.4 5.79s-4.41-2.59-4.41-5.79a6.86 6.86 0 0 1 .15-1.45 4.1 4.1 0 0 1 .1-.48c.45-.84 2.14-1.47 4.16-1.47s3.7.63 4.15 1.47a4.1 4.1 0 0 1 .1.48 6.86 6.86 0 0 1 .15 1.45z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <path
      d="M27.35 15.89h0c0 1-1.92 1.89-4.25 1.89s-4.23-.84-4.26-1.89h0a1 1 0 0 1 .11-.45c.45-.84 2.14-1.47 4.16-1.47s3.7.63 4.15 1.47a1 1 0 0 1 .09.45z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);

export const SVGProdBaba = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M25.9 16.1c-1.2-3.8-4.7-6.4-8.6-6.4s-7.5 2.6-8.6 6.4c-1.4 0-2.6 1.2-2.6 2.6s1.2 2.6 2.6 2.6c1.2 3.8 4.6 6.4 8.6 6.4s7.5-2.6 8.6-6.4c1.5 0 2.6-1.2 2.6-2.6s-1.2-2.6-2.6-2.6zm-5.3 6.4c-.9 1-2.1 1.5-3.4 1.5s-2.5-.5-3.4-1.5M19.7 6c1.7 1.1 2.4 3.2 1.8 5.1s-2.4 3.2-4.4 3.1-3.6-1-4.1-3"
    />
    <circle
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      cx={20.6}
      cy={17.6}
      r={0.5}
    />
    <circle
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      cx={14}
      cy={17.6}
      r={0.5}
    />
  </svg>
);

export const SVGProdBread = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M4 19.3c0-3 3.5-9.3 13-9.3s13 4.2 13 9.3-4.6 4.6-10.2 4.6H8.6c-1.4 0-4.6-1.1-4.6-4.6zm7.5-8.3c1.1.9 2.2 2.8 2.4 5.1 0 .2-.3.4-.4.2l-4-4.2m8.2-2c.9.9.8 3.1 1 5.1 0 .2-.2.3-.3.1l-3-5.1m8.1.8c.5.7.3 2.5.1 3.7 0 .3-.4.4-.6.1l-2.4-4.5"
    />
  </svg>
);

export const SVGProdCoffee = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g
      transform="translate(6 5)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7.2.8v3.8M11 .8v3.8M14.8.8v3.8m2.5 11.9c2.5.7 4.2 1.8 4.2 3 0 2.1-4.7 3.8-10.5 3.8S.5 21.6.5 19.5c0-1.2 1.6-2.3 4.2-3m-.5-6C3.5 15.8 5.4 18 5.4 18c.3.8 2.5 2.2 5.6 2.2s5.2-1.5 5.6-2.2c0 0 1.9-2.2 1.2-7.5" />
      <ellipse cx={11} cy={10.5} rx={6.8} ry={3} />
      <path d="M6 12.5l.5-.5c1.3-1 2.9-1.6 4.5-1.5 1.6-.1 3.2.5 4.5 1.5l.5.5" />
    </g>
  </svg>
);

export const SVGProdDrogeria = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 11l-1.1-1.7c-.1-.2-.3-.3-.6-.3h-1.6c-.3 0-.5.1-.6.3L15 11m2.5-6.3v4m3-4h-7.2c-.3 0-.6.1-.9.3l-1.9 1.7M13.5 18h7c.3 0 .5.2.5.5v5c0 .3-.2.5-.5.5h-7c-.3 0-.5-.2-.5-.5v-5c0-.3.2-.5.5-.5zm-1.2-7h9.3c1.4 0 2.4 1 2.4 2.2v13.5c0 1.2-1 2.2-2.3 2.2h-9.4C11 29 10 28 10 26.8V13.2c0-1.2 1-2.2 2.3-2.2z"
    />
  </svg>
);

export const SVGProdFagyasztott = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 5.8v7.5m3.8-6.1l-3.8 3-3.8-3m-5.9 4.2l6.5 3.8m-3.4-6.3l.7 4.7-4.5 1.7m.7 7.3l6.5-3.8m-7.1-.2l4.5 1.7-.7 4.7m6.5 3.2v-7.5m-3.8 6.1l3.8-3 3.8 3m5.9-4.2l-6.5-3.8m3.4 6.3l-.7-4.7 4.5-1.7m-.7-7.3l-6.5 3.8m7.1.2l-4.5-1.7.7-4.7M13.8 15.1v3.8l3.2 1.9 3.2-1.9v-3.8L17 13.2l-3.2 1.9z"
    />
  </svg>
);

export const SVGProdFruit = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.7 10.9c-.4-1-1-2-1.9-2.7-.7-.8-1.7-1.5-2.7-1.9-1.1-.4-2.3.1-2.8 1.2 0 0-4.9 7.7-6.7 11.4-.2.4-.1.9.2 1.3s.9.4 1.3.2c3.7-1.8 11.4-6.7 11.4-6.7 1.1-.6 1.6-1.8 1.2-2.8zm-1.9-2.7l2.4-2.4m-1.3 3.5l3.5-.6m-5.7-1.6l.6-3.5m-4.9 3.8l2.7 2.7m-6.9 4.3l2.1 2.1m2.8-3.6l2.5 2.5M22.4 17.6c-.5.2-.8 0-1.1-.2-5-3-5.9 2.1-5.4 5.3.6 3.5 2 6.5 4 6.7.2 0 .4 0 .6-.1l1.4-.7c.3-.2.7-.2 1 0l1.4.7c.2.1.4.1.6.1 2-.3 3.5-3.2 4-6.7.3-1.7.1-4-.8-5.2-.1 0-1-1.9-5.7.1z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M26.8 15.4c-.5.5-1.2.8-1.9 1-.2.1-.5 0-.7-.2-.2-.2-.2-.5-.2-.7.1-.7.5-1.4.9-2 .5-.5 1.2-.8 1.9-1 .2-.1.5 0 .7.2.2.2.2.5.2.7 0 .8-.4 1.5-.9 2zM22 14v3.4"
    />
  </svg>
);

export const SVGProdGift = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M26.8 16.2H7.2v10.5c0 .8.7 1.5 1.5 1.5h16.5c.8 0 1.5-.7 1.5-1.5V16.2zm0-4.4H7.2c-.8 0-1.5.7-1.5 1.5v2.2c0 .4.3.8.8.8h21c.4 0 .8-.3.8-.8v-2.2c-.1-.9-.7-1.5-1.5-1.5zm-10.6 0c-3.3 0-6.8-2.7-6.8-6 3.4 0 6.8 2.6 6.8 6m1.6 0c3.3 0 6.8-2.7 6.8-6-3.4 0-6.8 2.6-6.8 6"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M14.8 11.8h4.5v16.5h-4.5V11.8z"
    />
  </svg>
);

export const SVGProdHaztartas = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M24.5 9h4M24 7l3.5-1.5M24 11l3.5 1.5M12.5 6.5H19c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5H7.5c0-2.8 2.2-5 5-5zM11.5 11.5h4v4h-4v-4zm4.9 17h-5.7c-2.8 0-5.1-2.3-5.1-5.1 0-1.2.4-2.4 1.2-3.3l3.5-4.2c.2-.2.5-.4.8-.4H16c.3 0 .6.1.8.4l3.5 4.2c.8.9 1.2 2.1 1.2 3.3 0 2.8-2.3 5.1-5.1 5.1zm2.6-14c-1.7 0-3-1.3-3-3m5.5-4v3"
    />
  </svg>
);

export const SVGProdHusaru = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M27.2 13.5c.5.4 1.1.3 1.5-.1.4-.4.4-1.1 0-1.5-.6-.6-.8-.4-1-.6-.3-.3-.1-.5-.6-1-.4-.4-1.1-.4-1.6 0-.4.4-.4 1.2 0 1.6l-1 1 1.5 1.5 1.2-.9z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M28 24c0 .3-.3 1-1 1H6c-.7 0-1-.7-1-1 0-1.3.3-2 1-2h21c.7 0 1 .7 1 2zm-10.1-3.7c.2.4.5.8.9 1 .6.3 1.6.8 2.3.7 1.1-.1 2.1-.6 2.7-1.4l.1-.1.2-.2c1.1-1.7 1.2-4.1 1.7-4.6l.1-.1c.4-.4.4-.9 0-1.3l-1-1c-.4-.4-.9-.4-1.3 0l-.1.1c-.5.5-3.2.4-4.9 1.9l-.3.3c-.3.3-.6.9-.8 1.4-.3.7-.2 1.6 0 2.3l.4 1zm6-7.3c-2.2-3.9-12.7-7.4-17.5 3.2-1.4 3.1 1 5.8 4 5.8H21"
    />
  </svg>
);

export const SVGProdHutottelelmiszer = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g
      transform="translate(13 5)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7.5 15.4V3.8c0-1.7-1.3-3-3-3s-3 1.3-3 3v11.7c-1.4 1.2-1.9 3.2-1.2 5s2.3 2.9 4.2 2.9 3.5-1.2 4.2-2.9.2-3.8-1.2-5.1z" />
      <circle cx={4.5} cy={18.8} r={1.5} />
      <path d="M4.5 12.8v4.5" />
    </g>
  </svg>
);

export const SVGProdIroda = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M24.6 4.8s0 1.6 2 3.7c.1.1.2.2.3.4.8 1 .8 2.4 0 3.4s-2 1.5-3.2 1.1c-1.2-.4-2-1.5-2-2.8-.1-2.3 1-4.5 2.9-5.8zm0 22.4c.6 0 1.2-.2 1.6-.7.4-.4.6-1 .6-1.6l-1-11.7c-.7.3-1.6.3-2.3 0l-1 11.7c0 .6.2 1.2.6 1.6.3.5.9.7 1.5.7zM18.5 10l-2-4.7c-.1-.2-.4-.2-.5 0L14 10v14.9c0 1.2.8 2.2 2 2.4 1.3.1 2.5-.9 2.5-2.2V10zM14 10l2.2 1.5 2.2-1.5M14 23.5h4.5m-4.5-3h4.5M11 22l-2 4.7c-.1.2-.4.2-.5 0l-2-4.7V7.1c0-.8.4-1.7 1.2-2.1.9-.5 2-.3 2.7.4.4.4.6 1 .6 1.6v15zm-4.5 0H11M6.5 8.5H11M6.5 16H11"
    />
  </svg>
);

export const SVGProdKutya = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M12.1 7.9c1.3-1.3 3-2.1 4.8-2.1 1.8 0 3.6.7 4.9 2m3.3 10.7c-.7 5.1-3.2 9.8-8.1 9.8s-7.4-4.6-8.1-9.8"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M12.1 9c.2-.8 0-1.6-.6-2.1-.5-.6-1.3-.8-2.1-.7-1.3.4-2.5 1.3-3.1 2.5-1.2 1.8-.2 4.3.8 6.1.3.5.8.8 1.3.8.6 0 1.1-.3 1.3-.8 1-1.9 1.8-3.8 2.4-5.8zm9.7 0c-.2-.8 0-1.6.6-2.1.5-.6 1.3-.8 2.1-.6 1.3.3 2.5 1.2 3.1 2.4 1.1 1.9.2 4.4-.8 6.1-.3.5-.8.8-1.3.8-.6 0-1.1-.3-1.3-.8-1.1-1.9-1.9-3.8-2.4-5.8z"
    />
    <ellipse
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      cx={17}
      cy={21.5}
      rx={2.2}
      ry={1.5}
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M17.2 23.4c.5.9 2 3.1 3.9 3.5m-8.2-.1c2-.4 3.4-2.7 3.9-3.5"
    />
    <circle
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      cx={13.6}
      cy={15.1}
      r={0.5}
    />
    <circle
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      cx={20.2}
      cy={15.1}
      r={0.5}
    />
  </svg>
);

export const SVGProdMilk = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path d="M26 13.5L23 9l-3 4.5V29h5.1c.6 0 .9-.3.9-.9V13.5zM23 9H12l-3 4.2v14.9c0 .6.3.9.9.9H20m5.6-16H9.3M23 9V7.5c-.1-.9-1.3-1.6-2.8-1.5h-5.5c-1.5-.1-2.6.6-2.8 1.5V9" />
      <path d="M12 18h5v4h-5v-4z" />
    </g>
  </svg>
);

export const SVGProdSpecFood = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g
      transform="translate(5 5)"
      stroke="currentColor"
      strokeWidth={1.5}
      fill="none"
    >
      <path d="M18 18.37l-1.591-1.591M13.333 18.31a1.384 1.384 0 0 0 1.349-1.637 1.385 1.385 0 0 0-1.638-1.349c-1.03.1-2.921.957-2.841 1.782.08.825 2.097 1.304 3.13 1.204zm-3.752-3.751a1.384 1.384 0 0 0 1.349-1.637 1.381 1.381 0 0 0-1.637-1.349c-1.031.1-2.922.957-2.842 1.781.08.824 2.1 1.304 3.13 1.205zm8.359-.859a1.38 1.38 0 0 1-1.64 1.352 1.385 1.385 0 0 1-1.349-1.638c.1-1.03.957-2.921 1.782-2.842.825.079 1.307 2.1 1.207 3.128zm-3.751-3.749a1.384 1.384 0 0 1-1.637 1.349A1.382 1.382 0 0 1 11.2 9.663c.1-1.031.957-2.922 1.781-2.842.824.08 1.308 2.099 1.208 3.13zM8.984 7.233a1.384 1.384 0 0 1 0 2.121 1.384 1.384 0 0 1-2.121 0c-.732-.732-1.646-2.6-1.061-3.182.585-.582 2.45.328 3.182 1.061z" />
      <circle cx={12} cy={11.986} r={11.25} />
      <path d="M19.955 4.031L17.25 6.736M4.046 19.939l2.704-2.703" />
    </g>
  </svg>
);

export const SVGProdSutemeny = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g
      transform="translate(6 4)"
      stroke="currentColor"
      strokeWidth={1.5}
      fill="none"
    >
      <circle cx={9.73} cy={6.75} r={3.75} />
      <path d="M6.1 5.805C2.332 6.924.542 9.739.73 14.25v7.5a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5-1.5v-6.723a1.498 1.498 0 0 0-.63-1.227l-9.166-6.464m9.579 6.914H.73m22.283 4.5H.73m9.707-15.683A5.04 5.04 0 0 1 14.23.75" />
    </g>
  </svg>
);

export const SVGProdWater = (props: SVGPropType) => (
  <svg viewBox="0 0 34 34" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M13 23c-.2 0-1 1.3-1 2v5h10v-5c0-.7-.8-2-1-2m1-12c-.4-1.7-1.6-3.3-3-4h-4c-1.4.7-2.6 2.3-3 4m9 5c.2 0 1-1.1 1-3v-2H12v2c0 1.9.8 3 1 3M15 4h4v3h-4V4zm-2 12h8v7h-8v-7z" />
    </g>
  </svg>
);

export const SVGProfileDark = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g stroke="currentColor" strokeWidth={2} fill="none">
      <circle cx={12} cy={12} r={11} />
      <g transform="translate(7 5)">
        <circle cx={5} cy={3} r={3} />
        <path d="M5 6a5 5 0 0 1 5 5v1H0v-1a5 5 0 0 1 5-5z" />
      </g>
    </g>
  </svg>
);

export const SVGQuestionInCircle = (props: SVGPropType) => (
  <svg viewBox="0 0 27 27" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M13.5 27C6.045 27 0 20.955 0 13.5S6.045 0 13.5 0 27 6.045 27 13.5 20.955 27 13.5 27zm0-24.469C7.452 2.531 2.531 7.452 2.531 13.5c0 6.048 4.921 10.969 10.969 10.969 6.048 0 10.969-4.921 10.969-10.969 0-6.048-4.921-10.969-10.969-10.969zm-1.364 16.157c0 1.936 2.944 1.936 2.944 0 0-1.952-2.944-1.936-2.944 0zm-.128-7.512H9.512c0-2.336 1.776-3.632 4.208-3.632 2.24 0 3.84.848 4.224 2.64.64 3.296-3.12 2.784-3.12 5.264h-2.48c.064-3.744 3.296-2.912 3.04-4.736-.112-.656-.768-1.008-1.664-1.008-.96 0-1.664.576-1.712 1.472z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const SVGSavedCard = (props: SVGPropType) => (
  <svg viewBox="0 0 28.5 23.5" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          d="M3.5 15.75H14a.75.75 0 0 1 .75.75.75.75 0 0 1-.75.75H3.5a.75.75 0 0 1-.75-.75.75.75 0 0 1 .75-.75zM3.5 18.75H9a.75.75 0 0 1 .75.75.75.75 0 0 1-.75.75H3.5a.75.75 0 0 1-.75-.75.75.75 0 0 1 .75-.75zM.75 9.75h15.657l3.399 3H.75v-3z"
          fill="currentColor"
          fillRule="evenodd"
        />
        <path
          d="M15.75 6.75h-13a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h21a2 2 0 0 0 2-2v-8.8"
          fill="none"
          stroke="currentColor"
          strokeLinecap="square"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <g
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        >
          <path d="M21.75.75a6 6 0 1 1-6 6 6 6 0 0 1 6-6z" />
          <path d="M18.75 6.75l2 2 4-4" />
        </g>
      </g>
    </g>
  </svg>
);

export const SVGShareField = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M12.8 8.5V5l8.2 5.9-8.2 5.9v-3.5c-3.3 0-6.2.1-8.8 4.7 0-2.9.3-9.5 8.8-9.5z"
      fill="currentColor"
    />
  </svg>
);

export const SVGShare = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M12.793 8.545V5L21 10.909l-8.207 5.909v-3.545C9.54 13.273 6.55 13.391 4 18c0-2.925.293-9.455 8.793-9.455z"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
    />
  </svg>
);

export const SVGShipping2 = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M28 21.143L19.5 24 11 21.143V10.857L19.5 8l8.5 2.857zM28 11l-8.5 2.826L11 11m8.5 2.826V24M8.643 11.75H1.961m6.682 9H1.961m12.536-4.328H5.961"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
    />
  </svg>
);

export const SVGShippingAddress = (props: SVGPropType) => (
  <svg viewBox="0 0 19.5 25.5" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          d="M9.75 24.75q9-9.843 9-14.88a9.06 9.06 0 0 0-9-9.12 9.06 9.06 0 0 0-9 9.12q0 5.037 9 14.88z"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
        />
        <g fill="currentColor" fillRule="evenodd">
          <path d="M10.75 15.25v-2a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z" />
          <path d="M5.957 10.75h7.586a.5.5 0 0 0 .353-.854l-3.792-3.792a.5.5 0 0 0-.708 0L5.604 9.896a.5.5 0 0 0 .353.854z" />
        </g>
      </g>
    </g>
  </svg>
);

export const SVGShippingCar = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g transform="translate(1 7)" fill="none" stroke="currentColor" strokeWidth={2}>
      <path d="M20 5h5.2L29 9.7V12" />
      <circle cx={10} cy={17} r={2} />
      <circle cx={24} cy={17} r={2} />
      <path d="M20.9 15H20v-4h9v4h-8.1zM2 7.9h8.5M.2 11.2h8.5M5 12v3h15V0H5v4.5h7.9" />
    </g>
  </svg>
);

export const SVGShippingCarDont = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g
      transform="translate(4 4)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
    >
      <g transform="translate(1 7)">
        <path d="M13.7 2.7H17l2.3 2.9v1.5" />
        <circle cx={7.4} cy={10.2} r={1.3} />
        <circle cx={16.2} cy={10.2} r={1.3} />
        <path d="M14.2 8.9h-.6V6.4h5.6v2.5h-5zM2.4 4.5h5.3M1.3 6.6h5.3" />
        <path d="M4.3 7.1V9h9.4V-.4H4.3v2.8h4.9" />
      </g>
      <circle cx={12} cy={12} r={12} />
      <path d="M20.2 3.5L3.6 20.7" />
    </g>
  </svg>
);

export const SVGShoppingList = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g stroke="currentColor" strokeWidth={2} fill="none">
      <rect x={2} y={1} width={28} height={30} rx={2} />
      <path d="M19 12h6m-6 9h6M7 12.293L9.009 14 14 9M7 21.293L9.009 23 14 18" />
    </g>
  </svg>
);

export const SVGShopsIcon = (props: SVGPropType) => (
  <svg viewBox="0 0 36 31" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M25.545 17.1h-4.886a2.426 2.426 0 0 0-2.424 2.424v3.747a2.426 2.426 0 0 0 2.424 2.424h4.886a2.426 2.426 0 0 0 2.424-2.424v-3.747a2.426 2.426 0 0 0-2.424-2.424zm.661 6.171a.663.663 0 0 1-.661.661h-4.886a.663.663 0 0 1-.661-.661v-3.747c0-.367.301-.661.661-.661h4.886c.367 0 .661.301.661.661v3.747zm9.75-12.982a.816.816 0 0 0-.118-.433L30.489.452a.885.885 0 0 0-.764-.448H6.222a.87.87 0 0 0-.764.448L.117 9.856a.895.895 0 0 0-.118.433 5.157 5.157 0 0 0 3.086 4.717v15.509c0 .485.397.882.882.882h28.014a.885.885 0 0 0 .882-.882V15.116l-.007-.096a5.172 5.172 0 0 0 3.1-4.731zM6.737 1.774h22.474l4.18 7.354H2.563l4.173-7.354zm18.852 9.11c-.279 1.587-1.668 2.792-3.336 2.792s-3.056-1.205-3.336-2.792h6.671zm-8.544 0c-.279 1.587-1.668 2.792-3.336 2.792s-3.056-1.205-3.343-2.792h6.678zm-15.223 0H8.5a3.394 3.394 0 0 1-3.343 2.792 3.381 3.381 0 0 1-3.336-2.792zm12.989 18.749H9.742v-9.514c0-.691.558-1.256 1.256-1.256h2.564c.691 0 1.256.558 1.256 1.256v9.514h-.007zm16.288 0H16.574v-9.514c0-1.66-1.352-3.02-3.02-3.02H10.99a3.025 3.025 0 0 0-3.02 3.02v9.522H4.848V15.439l.309.007c1.778 0 3.35-.904 4.276-2.278a5.151 5.151 0 0 0 8.552 0 5.139 5.139 0 0 0 8.538 0 5.151 5.151 0 0 0 4.276 2.278l.301-.007v14.194zm-.301-15.95a3.388 3.388 0 0 1-3.336-2.792h6.678a3.407 3.407 0 0 1-3.343 2.792z"
      fill="currentColor"
    />
  </svg>
);

export const SVGSmallArrowDown = (props: SVGPropType) => (
  <svg viewBox="0 0 14 14" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path fill="currentColor" d="M7 9.7l3.5-4h-7l3.5 4z" />
  </svg>
);

export const SVGSocialEmail = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path d="M7.8 8.8h16.5c1.1 0 2 .9 2 2v10.5c0 1.1-.9 2-2 2H7.8c-1.1 0-2-.9-2-2V10.8c0-1.2.8-2 2-2z" />
      <path d="M6.6 9.4l9.4 8.1 9.6-8M13.3 15.4l-6.9 7.3M18.7 15.3l7.2 7.1" />
    </g>
  </svg>
);

export const SVGSocialFacebook = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M11.287 16.587h1.953v8.123c0 .16.129.29.287.29h3.311c.159 0 .287-.13.287-.29v-8.085h2.245a.288.288 0 0 0 .285-.257l.341-2.99a.29.29 0 0 0-.285-.323h-2.586V11.18c0-.565.301-.852.895-.852h1.691c.159 0 .287-.13.287-.29V7.293c0-.16-.129-.29-.287-.29h-2.33l-.107-.002c-.404 0-1.81.08-2.92 1.112-1.23 1.143-1.059 2.512-1.018 2.75v2.192h-2.05a.288.288 0 0 0-.287.29v2.952c0 .16.129.29.287.29z"
      fill="currentColor"
    />
  </svg>
);

export const SVGSocialGetlink = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.1 13.5c-.8-1-2.1-1.5-3.3-1.5H9.2c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5h1.5c1.3 0 2.5-.5 3.3-1.5m3.9-6c.8-1 2.1-1.5 3.3-1.5h1.5c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5h-1.5c-1.3 0-2.5-.5-3.3-1.5m-7.1-3h10.5"
    />
  </svg>
);

export const SVGSocialGplus = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M12.42 18.047a.51.51 0 0 1-.515-.503v-1.842c0-.278.23-.503.515-.503h6.933s-.004 1.672-.01 1.721c-.224 3.946-3.57 7.078-7.665 7.078-4.259 0-7.708-3.387-7.678-7.553.029-4.136 3.598-7.526 7.831-7.445a7.748 7.748 0 0 1 5.126 2.053.495.495 0 0 1-.001.731l-1.377 1.266a.525.525 0 0 1-.702.002 4.808 4.808 0 0 0-3.198-1.208c-2.689 0-4.865 2.188-4.76 4.838.098 2.472 2.192 4.45 4.724 4.469 2.087.015 3.87-1.288 4.528-3.106h-3.75zm13.287-2.68h1.842c.249 0 .451.197.451.44v1.514c0 .243-.202.44-.451.44h-1.842v1.799c0 .243-.202.44-.451.44h-1.55a.446.446 0 0 1-.451-.44v-1.799h-1.842a.446.446 0 0 1-.451-.44v-1.514c0-.243.202-.44.451-.44h1.842v-1.799c0-.243.202-.44.451-.44h1.55c.249 0 .451.197.451.44v1.799z"
      fill="currentColor"
    />
  </svg>
);

export const SVGSocialInstagram = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g transform="translate(5 5)" fill="#141B4D">
      <path d="M15.419 0H6.542A6.55 6.55 0 0 0 0 6.542v8.877a6.55 6.55 0 0 0 6.542 6.542h8.877a6.55 6.55 0 0 0 6.542-6.542V6.542A6.55 6.55 0 0 0 15.419 0zm4.333 15.419a4.333 4.333 0 0 1-4.333 4.333H6.542a4.333 4.333 0 0 1-4.333-4.333V6.542a4.333 4.333 0 0 1 4.333-4.333h8.877a4.333 4.333 0 0 1 4.333 4.333v8.877zM10.981 5.301a5.686 5.686 0 0 0-5.68 5.68 5.686 5.686 0 0 0 5.68 5.68 5.686 5.686 0 0 0 5.68-5.68 5.686 5.686 0 0 0-5.68-5.68zm0 9.151a3.471 3.471 0 1 1 0-6.942 3.471 3.471 0 0 1 0 6.942z" />
      <circle cx={16.672} cy={5.343} r={1.361} />
    </g>
  </svg>
);

export const SVGSocialYoutube = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="#141B4D"
      d="M29 10.6c0-2-1.7-3.6-3.9-3.6H6.9C4.7 7 3 8.6 3 10.6v9.7c0 2 1.7 3.6 3.9 3.6h18.2c2.1 0 3.9-1.6 3.9-3.6v-9.7zm-15.7 9.3v-9.2l7.4 4.6-7.4 4.6z"
    />
  </svg>
);

export const SVGStarActive = (props: SVGPropType) => (
  <svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M8 12.04l-4.326 2.274.826-4.817L1 6.085l4.837-.703L8 .999l2.163 4.383L15 6.085l-3.5 3.412.826 4.817z"
      fill="#FFD500"
      stroke="#FFD500"
    />
  </svg>
);

export const SVGStarNormal = (props: SVGPropType) => (
  <svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="none"
      stroke="#FFD500"
      d="M11.7 13.4L11 9.3l3-2.9-4.2-.6L8 2.1 6.2 5.8l-4.1.6 3 2.9-.7 4.1L8 11.5l3.7 1.9z"
    />
  </svg>
);

export const SVGSupport = (props: SVGPropType) => (
  <svg viewBox="0 0 36 36" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M9.017 23.637a.748.748 0 0 0-1.055.089l-.303.372a.748.748 0 1 0 1.178.925l.269-.33a.75.75 0 0 0-.088-1.055zM22.828 8.968a.745.745 0 0 0 1.056-.071l.28-.351a.748.748 0 1 0-1.215-.875l-.192.241a.749.749 0 0 0 .071 1.056zm12.353 22.47H34.04a16.04 16.04 0 0 0-2.412-7.759 16.148 16.148 0 0 0-5.7-5.478c.096-.253.187-.534.273-.85h1.543a2.549 2.549 0 0 0 2.546-2.546v-2.359A2.549 2.549 0 0 0 27.744 9.9h-.266c.065-1.017.029-1.996-.206-2.783-.649-2.173-1.881-3.987-3.562-5.244C22.072.648 20.085 0 17.964 0c-2.121 0-4.108.648-5.746 1.873-1.681 1.258-2.913 3.071-3.562 5.244-.235.787-.271 1.766-.206 2.783h-.265a2.549 2.549 0 0 0-2.546 2.546v2.359a2.549 2.549 0 0 0 2.546 2.546h1.543c.087.316.177.597.273.85a16.157 16.157 0 0 0-5.7 5.478 16.04 16.04 0 0 0-2.412 7.759H.749a.75.75 0 0 0 0 1.498h6.778l.738 2.461a.747.747 0 0 0 .717.533h17.964a.749.749 0 0 0 .717-.533l.738-2.461h6.778a.75.75 0 0 0 0-1.498zM26.72 14.83l.167-.906c.142-.738.31-1.617.436-2.527h.421a1.05 1.05 0 0 1 1.049 1.049v2.359a1.05 1.05 0 0 1-1.049 1.049h-1.205c.06-.316.12-.656.181-1.025zM8.185 15.855a1.05 1.05 0 0 1-1.049-1.049v-2.359a1.05 1.05 0 0 1 1.049-1.049h.421c.126.909.294 1.788.436 2.526l.167.907c.061.368.121.708.181 1.025H8.185zm1.76-6.046c-.057-.86-.033-1.664.146-2.262 1.115-3.731 4.132-6.049 7.874-6.049 3.743 0 6.76 2.318 7.874 6.049.224.75.205 1.824.089 2.925l-.022.179.001.016c-.124 1.074-.331 2.158-.489 2.977-.071.368-.132.686-.174.944a33.18 33.18 0 0 1-.301 1.626c-1.104 1.003-2.983 1.69-4.891 1.853a.748.748 0 0 0-.739-.637h-1.347a.75.75 0 0 0-.749.749v.599l.001.024.002.045.004.031.006.042.008.033.01.037.012.035.012.033.016.036.014.03.019.034.017.028.022.031.021.028.023.027.025.027.024.023.029.026.025.02.032.024.027.017.034.021.03.016.034.017.035.014.032.012.041.012.031.008.044.008.024.004.014.001.006.001c.426.053.861.079 1.299.079 1.689 0 3.42-.382 4.847-1.046-.357.445-.82.74-1.487 1.164-.279.177-.594.378-.944.615-1.209.694-2.434 1.045-3.64 1.045-1.207 0-2.431-.352-3.64-1.045a40.432 40.432 0 0 0-.944-.615c-1.329-.845-1.851-1.178-2.326-3.206l-.035-.151a31.068 31.068 0 0 1-.333-1.775l-.174-.945c-.126-.658-.285-1.486-.407-2.343 1.374-.192 4.321-.689 6.306-1.642l.492 1.179.128.319c.165.421.322.819.79.976.112.038.22.055.33.055.262 0 .538-.094.921-.225l.358-.121c.519-.171 1.561-.688 2.548-1.344a.749.749 0 0 0-.829-1.247c-.921.612-1.833 1.052-2.188 1.169l-.372.126-.166.056-.137-.341-.813-1.951a.749.749 0 0 0-1.099-.339c-1.619 1.056-4.94 1.626-6.427 1.837zm17.186 22.155l-.001.003-.74 2.467h-1.698l.312-1.163a.749.749 0 0 0-1.446-.388l-.415 1.551H9.54l-.739-2.462-.003-.011-1.055-3.516h1.65l.415 1.551a.75.75 0 0 0 .723.555l.194-.026a.749.749 0 0 0 .529-.917l-.312-1.163h17.244l-1.056 3.519zm1.721-.525l1.058-3.527a.75.75 0 0 0-.717-.964H6.737a.75.75 0 0 0-.717.964l1.058 3.527H3.387a14.535 14.535 0 0 1 7.341-11.929c.324.398.713.715 1.201 1.049-.73.379-1.426.828-2.069 1.335a.748.748 0 1 0 .927 1.176 11.615 11.615 0 0 1 1.894-1.214l.693-.356.133.089.046.029c1.447.835 2.931 1.259 4.411 1.259 1.48 0 2.965-.424 4.412-1.259l.046-.029c.342-.232.655-.431.931-.606.807-.513 1.392-.912 1.848-1.472a14.535 14.535 0 0 1 7.341 11.929h-3.691zm-17.904-.084a.749.749 0 0 0-.529.917l.087.326a.75.75 0 0 0 .723.555l.194-.026a.749.749 0 0 0 .529-.917l-.087-.326a.749.749 0 0 0-.917-.529zm13.749.166l.194.026a.75.75 0 0 0 .723-.555l.087-.326a.749.749 0 0 0-1.446-.388l-.087.326c-.107.399.13.81.529.917z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.5}
    />
  </svg>
);

export const SVGTelephoneTiny = (props: SVGPropType) => (
  <svg viewBox="0 0 10 10" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M9.995 7.892a.485.485 0 0 1-.148.424L8.439 9.714a.78.78 0 0 1-.249.18 1.033 1.033 0 0 1-.302.095l-.064.005-.138.005c-.134 0-.351-.023-.651-.069-.3-.046-.667-.159-1.101-.339-.434-.18-.926-.45-1.477-.81-.55-.36-1.136-.855-1.757-1.483A11.608 11.608 0 0 1 1.472 5.9a9.836 9.836 0 0 1-.783-1.234 6.614 6.614 0 0 1-.445-1.028 5.394 5.394 0 0 1-.201-.794 2.642 2.642 0 0 1-.042-.524l.011-.212c.014-.099.046-.2.095-.302a.79.79 0 0 1 .18-.249L1.695.148A.466.466 0 0 1 2.034 0c.092 0 .173.026.243.079a.719.719 0 0 1 .18.196l1.133 2.15a.515.515 0 0 1 .053.371.658.658 0 0 1-.18.339l-.519.519-.037.069-.016.079c.028.148.092.318.191.508.085.169.215.376.392.62.176.244.427.524.752.842.318.325.6.577.847.757.247.18.453.312.619.397.166.085.293.136.381.154l.132.027.069-.016.069-.037.603-.614a.647.647 0 0 1 .445-.169c.12 0 .215.021.286.064h.011l2.043 1.208a.536.536 0 0 1 .265.35z"
      fill="currentColor"
    />
  </svg>
);

export const SVGThickWhite = (props: SVGPropType) => (
  <svg viewBox="0 0 29 22" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      fill="#FFF"
      d="M10.5 22c-.7 0-1.3-.3-1.8-.7l-8-8c-1-1-1-2.6 0-3.5 1-1 2.6-1 3.5 0l6.2 6.2L24.7.8c.9-1 2.5-1.1 3.5-.1 1 .9 1.1 2.5.1 3.5l-16 17c-.4.5-1.1.8-1.8.8z"
    />
  </svg>
);

export const SVGTickSuccess = (props: SVGPropType) => (
  <svg viewBox="0 0 71 71" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M54.07 6.419A34.339 34.339 0 0 0 35.5 1C16.446 1 1 16.446 1 35.5 1 54.554 16.446 70 35.5 70 54.554 70 70 54.554 70 35.5c0-3.429-.5-6.74-1.431-9.866" />
      <path d="M20 36l9.567 9.567a2 2 0 0 0 2.847-.02L68 9" />
    </g>
  </svg>
);

export const SVGTickTiny = (props: SVGPropType) => (
  <svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <circle fill="none" stroke="#FF7716" cx={8} cy={8} r={6} />
    <path fill="#FFF" stroke="#FF7716" d="M5.1 8.3l1.8 1.6 3.7-4" />
  </svg>
);

export const SVGTick = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      stroke="currentColor"
      strokeWidth={2}
      d="M24.092 10L12.971 21.429 8 16.467"
      fill="none"
    />
  </svg>
);

export const SVGTrashSmall = (props: SVGPropType) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <path
      d="M5 6h14M8.818 6V4.975c0-.538.556-.975 1.241-.975h3.882c.685 0 1.241.437 1.241.975V6m2.434.05l-.386 12.631c-.015.723-.932 1.305-1.682 1.319H8.452c-.75-.014-1.63-.597-1.645-1.319L6.128 6.05M12 8.186v9.147M9.455 8.666v8.667m5.168-8.667v8.667"
      stroke="currentColor"
      strokeWidth={1.5}
      fill="none"
    />
  </svg>
);

export const SVGUserFilled = (props: SVGPropType) => (
  <svg viewBox="0 0 17.212 19.001" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g data-name="Layer 2">
      <g data-name="Layer 1" fill="#18a2dc">
        <circle cx={8.622} cy={4} r={4} />
        <path d="M8.674 10q5.66 0 8.37 6.199a2 2 0 0 1-1.832 2.802H2a2 2 0 0 1-1.882-2.677Q2.392 10 8.674 10.001z" />
      </g>
    </g>
  </svg>
);

export const SVGUser = (props: SVGPropType) => (
  <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <g transform="translate(7 6)" stroke="#18A2DC" strokeWidth={2} fill="none">
      <circle cx={9} cy={4} r={4} />
      <path d="M9.052 10c3.773 0 6.563 2.066 8.37 6.199a2 2 0 0 1-1.832 2.802H2.378a2 2 0 0 1-1.882-2.677c1.516-4.216 4.368-6.323 8.556-6.323z" />
    </g>
  </svg>
);

export const SVGWait = (props: SVGPropType) => (
  <svg viewBox="0 0 16 16" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <circle fill="#7C81A0" stroke="#7C81A0" cx={8} cy={8} r={6} />
    <path
      fill="none"
      stroke="#FFF"
      strokeMiterlimit={10}
      d="M8 3.7v4.4l2.2 2.7"
    />
  </svg>
);

export const SVGWithoutGluten = (props: SVGPropType) => (
  <svg viewBox="0 0 71.6 71.6" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <defs>
      <clipPath id="a">
        <path
          d="M35.8 71.6a35.8 35.8 0 1 1 35.8-35.8 35.84 35.84 0 0 1-35.8 35.8z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g data-name="Layer 2">
      <path
        d="M35.8 71.6a35.8 35.8 0 1 1 35.8-35.8 35.84 35.84 0 0 1-35.8 35.8z"
        fill="#5fcc5f"
      />
      <path
        d="M27.704 32.894l5.847 4.471v-5.869l-5.847-4.472zm0 5.235v6.412l5.847 4.547v-6.487zm10.011-.737l5.761-4.406V27.11l-5.76 4.392zm0 5.214v6.466l5.761-4.532v-6.326l-5.76 4.393zM27.704 21.789l5.847 4.471V13.638a2.082 2.082 0 1 1 4.164 0v12.65l5.761-4.406v-5.64a2.082 2.082 0 0 1 4.164 0v30.33l-9.925 7.816v4.293a2.082 2.082 0 1 1-4.164 0V54.38L23.54 46.57V16.242a2.082 2.082 0 0 1 4.164 0z"
        fill="#fff"
      />
      <g clipPath="url(#a)" fill="#fff">
        <path d="M65.8 10.07L43.476 27.024l3 3.8L68.7 13.87l-2.9-3.8zM3.3 57.77l3 3.8 20.839-16.027-2.9-3.8L3.3 57.77z" />
      </g>
    </g>
  </svg>
);

export const SVGWithoutLactose = (props: SVGPropType) => (
  <svg viewBox="0 0 71.6 71.6" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <defs>
      <clipPath id="a">
        <path
          d="M35.8 71.6a35.8 35.8 0 1 1 35.8-35.8 35.84 35.84 0 0 1-35.8 35.8z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g data-name="Layer 2">
      <path
        data-name="Shape"
        d="M35.8 71.6a35.8 35.8 0 1 1 35.8-35.8 35.84 35.84 0 0 1-35.8 35.8z"
        fill="#87bcde"
      />
      <path
        d="M49.6 34.22a14.014 14.014 0 0 0-4.3-10.02 5.078 5.078 0 0 1-1.98-3.88v-2.48a4.634 4.634 0 0 0-1.56-9H29.4a4.634 4.634 0 0 0-1.56 9v2.56a5.272 5.272 0 0 1-2.1 4.02 13.844 13.844 0 0 0-4.08 9.84v19.6a7.725 7.725 0 0 0 7.72 7.72H41.8a7.798 7.798 0 0 0 7.82-7.72zM29.42 11.94h12.36a1.54 1.54 0 0 1 0 3.08H29.42a1.54 1.54 0 0 1 0-3.08zm-1.46 14.68a8.198 8.198 0 0 0 3.02-6.22v-2.28h9.26v2.22a7.763 7.763 0 0 0 2.36 5.56l.56.54a10.915 10.915 0 0 1 3.38 7.8v5.6c-2.92.34-6.98.84-9.38-.76l-1.4-.94c-3.28-2.18-7.1-2.62-10.96-2.26.08-2.74 1.2-7.32 3.16-9.26z"
        fill="#fff"
      />
      <path d="M32.572 45.395h2.602v9.146h4.191v2.27h-6.793z" fill="#87bcde" />
      <g clipPath="url(#a)" fill="#fff">
        <path d="M31.896 41.801L6.676 61.057 3.76 57.241 28.506 38.35zM44.815 25.896l20.11-15.354 2.913 3.817L47.287 30.05z" />
      </g>
    </g>
  </svg>
);

export const SVGWithoutSugar = (props: SVGPropType) => (
  <svg viewBox="0 0 71.6 71.6" width="1em" height="1em" {...props}>
    {getTitle(props.title)}
    <defs>
      <clipPath id="a">
        <path
          d="M35.8 71.6a35.8 35.8 0 1 1 35.8-35.8 35.892 35.892 0 0 1-35.8 35.8z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g data-name="Layer 2">
      <path
        data-name="Shape"
        d="M35.8 71.6a35.8 35.8 0 1 1 35.8-35.8 35.892 35.892 0 0 1-35.8 35.8z"
        fill="#ffbc00"
      />
      <g clipPath="url(#a)">
        <path d="M3.1 57.75l62.5-47.7 2.9 3.8-62.4 47.7z" fill="#fff" />
      </g>
      <path
        fill="#ffbc00"
        d="M35.605 11.435l9.936 5.751.707 12.284-10.643 6.126L24.8 29.705l.56-12.748 10.245-5.522zM46.605 30.435l9.936 5.751.707 12.284-10.643 6.126L35.8 48.705l.56-12.748 10.245-5.522z"
      />
      <path
        d="M35.8 37.451a1.696 1.696 0 0 1-.846-.226l-10.4-6.005a1.695 1.695 0 0 1-.845-1.464v-12.01a1.694 1.694 0 0 1 .846-1.465l10.4-6.005a1.691 1.691 0 0 1 1.691 0l10.4 6.005a1.695 1.695 0 0 1 .846 1.465v12.01a1.694 1.694 0 0 1-.846 1.464l-10.4 6.005a1.696 1.696 0 0 1-.846.226zM37.087 34l8.232-4.753v-9.508l-8.232 4.752zm-2.574 0V24.49l-8.232-4.752v9.508zM35.8 22.262l8.229-4.752-8.229-4.75-8.229 4.751z"
        fill="#fff"
      />
      <path
        fill="#ffbc00"
        d="M25.605 30.435l9.936 5.751.707 12.284-10.643 6.126L14.8 48.705l.56-12.748 10.245-5.522z"
      />
      <path
        d="M24.995 56.127a1.697 1.697 0 0 1-.846-.227l-10.4-6.005a1.695 1.695 0 0 1-.846-1.464V36.42a1.694 1.694 0 0 1 .847-1.465l10.4-6.004a1.691 1.691 0 0 1 1.691 0l10.4 6.004a1.695 1.695 0 0 1 .846 1.465v12.01a1.694 1.694 0 0 1-.847 1.464L25.84 55.9a1.696 1.696 0 0 1-.845.227zm1.286-3.453l8.232-4.753v-9.508l-8.232 4.752zm-2.573 0v-9.509l-8.232-4.752v9.508zm1.287-11.737l8.229-4.751-8.23-4.751-8.228 4.75z"
        fill="#fff"
      />
      <path
        d="M46.605 56.127a1.696 1.696 0 0 1-.845-.227l-10.4-6.005a1.695 1.695 0 0 1-.846-1.464V36.42a1.694 1.694 0 0 1 .846-1.465l10.4-6.004a1.691 1.691 0 0 1 1.692 0l10.4 6.004a1.695 1.695 0 0 1 .846 1.465v12.01a1.694 1.694 0 0 1-.847 1.464l-10.4 6.005a1.697 1.697 0 0 1-.846.227zm1.287-3.453l8.232-4.753v-9.508l-8.232 4.752zm-2.573 0v-9.509l-8.232-4.752v9.508zm1.286-11.737l8.23-4.751-8.23-4.751-8.229 4.75z"
        fill="#fff"
      />
    </g>
  </svg>
);
export const SVGCalendar = (props: SVGPropType) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
    <path d="M25.7969 16.2305V6.00468C25.7969 5.57324 25.4471 5.22344 25.0156 5.22344H21.2408V4.78125C21.2408 4.3498 20.891 4 20.4595 4C20.0281 4 19.6783 4.3498 19.6783 4.78125V5.22344H17.2001V4.78125C17.2001 4.3498 16.8503 4 16.4189 4C15.9874 4 15.6376 4.3498 15.6376 4.78125V5.22344H13.1592V4.78125C13.1592 4.3498 12.8094 4 12.378 4C11.9465 4 11.5967 4.3498 11.5967 4.78125V5.22344H9.11854V4.78125C9.11854 4.3498 8.76874 4 8.33729 4C7.90585 4 7.55605 4.3498 7.55605 4.78125V5.22344H3.78125C3.3498 5.22344 3 5.57324 3 6.00468V24.0859C3 24.5173 3.3498 24.8671 3.78125 24.8671H17.145C18.2722 26.2177 19.9673 27.0786 21.8599 27.0786C25.2456 27.0786 28 24.3241 28 20.9384C28 19.0498 27.1426 17.3578 25.7969 16.2305ZM7.55609 6.78593V7.22787C7.55609 7.65932 7.9059 8.00912 8.33734 8.00912C8.76879 8.00912 9.11859 7.65932 9.11859 7.22787V6.78593H11.5968V7.22787C11.5968 7.65932 11.9466 8.00912 12.378 8.00912C12.8095 8.00912 13.1593 7.65932 13.1593 7.22787V6.78593H15.6377V7.22787C15.6377 7.65932 15.9875 8.00912 16.4189 8.00912C16.8504 8.00912 17.2002 7.65932 17.2002 7.22787V6.78593H19.6783V7.22787C19.6783 7.65932 20.0281 8.00912 20.4596 8.00912C20.891 8.00912 21.2408 7.65932 21.2408 7.22787V6.78593H24.2344V9.08749H4.5625V6.78593H7.55609ZM4.5625 23.3047V10.65H24.2344V15.2762C23.5036 14.9686 22.7013 14.7983 21.8599 14.7983C18.4743 14.7983 15.7198 17.5528 15.7198 20.9384C15.7198 21.7766 15.8888 22.576 16.1943 23.3047H4.5625ZM21.8599 25.5161C19.3358 25.5161 17.2822 23.4626 17.2822 20.9384C17.2822 18.4143 19.3358 16.3608 21.8599 16.3608C24.384 16.3608 26.4375 18.4143 26.4375 20.9384C26.4375 23.4626 24.384 25.5161 21.8599 25.5161ZM22.6411 18.2946V20.9384C22.6411 21.1549 22.5514 21.3615 22.3933 21.5093L20.8494 22.9519C20.6988 23.0926 20.5072 23.1623 20.3162 23.1623C20.1073 23.1623 19.899 23.0791 19.7452 22.9144C19.4506 22.5991 19.4674 22.1048 19.7826 21.8102L21.0787 20.5992V18.2945C21.0787 17.8631 21.4285 17.5133 21.8599 17.5133C22.2914 17.5133 22.6411 17.8631 22.6411 18.2946ZM10.1683 12.4661H7.72694C7.2955 12.4661 6.9457 12.8159 6.9457 13.2473V15.6887C6.9457 16.1202 7.2955 16.47 7.72694 16.47H10.1683C10.5998 16.47 10.9496 16.1202 10.9496 15.6887V13.2473C10.9496 12.8159 10.5998 12.4661 10.1683 12.4661ZM9.3871 14.9075H8.50819V14.0286H9.3871V14.9075ZM10.1683 17.8257H7.72694C7.2955 17.8257 6.9457 18.1755 6.9457 18.6069V21.0483C6.9457 21.4798 7.2955 21.8296 7.72694 21.8296H10.1683C10.5998 21.8296 10.9496 21.4798 10.9496 21.0483V18.6069C10.9496 18.1754 10.5998 17.8257 10.1683 17.8257ZM9.3871 20.2671H8.50819V19.3882H9.3871V20.2671ZM16.3092 15.6887V13.2473C16.3092 12.8159 15.9594 12.4661 15.5279 12.4661H13.0865C12.6551 12.4661 12.3053 12.8159 12.3053 13.2473V15.6887C12.3053 16.1202 12.6551 16.47 13.0865 16.47H15.5279C15.9594 16.47 16.3092 16.1202 16.3092 15.6887ZM14.7467 14.9075H13.8678V14.0286H14.7467V14.9075Z" fill="#00A3E0" />
  </svg>

);
const allItems: SVGItemsType = { SVGGoogleGLogo,SVGAccMinus,SVGAccPlus,SVGAddToList,SVGAddedToList,SVGArrowBack,SVGArrowDown,SVGArrowNext,SVGArrow,SVGBankCard,SVGBankTransfer,SVGBasketIconBlue,SVGBasketIcon,SVGBfLogo,SVGBillingAddress,SVGCancel,SVGCashOnDelivery,SVGClock,SVGClose,SVGContactActive,SVGContact,SVGDropPackage,SVGEditDisabled,SVGEdit,SVGEmptyPreviousOrder,SVGEmptyShoppingList,SVGError500Img,SVGExit,SVGFalse,SVGFilter,SVGGrobyLogoBorder,SVGGrobyLogoSymbol,SVGGrobyLogoBlack,SVGGrobyLogoCheckout,SVGHistory,SVGIconBasket,SVGIconDanger,SVGIconLink,SVGIconSmileHappy,SVGIconSmileSad,SVGIconWarningLabel,SVGIllustration404,SVGLink,SVGListShareAdd,SVGListShareAdded,SVGList,SVGLogin,SVGLogout,SVGMagnifierGlass,SVGMinus,SVGMore,SVGNavHome,SVGNavIcon,SVGNavSearch,SVGNavicon1,SVGNavicon2,SVGNavicon3,SVGNewCard,SVGNew,SVGOk,SVGOkoslista,SVGPackage,SVGPaperPlane,SVGPercent,SVGPhoneReceiver,SVGPinGrey,SVGPlusOrange,SVGPlusLarge,SVGPlus,SVGPreviousOrder,SVGProdAlapvetoelelmiszer,SVGProdAlcoholicDrinks,SVGProdBaba,SVGProdBread,SVGProdCoffee,SVGProdDrogeria,SVGProdFagyasztott,SVGProdFruit,SVGProdGift,SVGProdHaztartas,SVGProdHusaru,SVGProdHutottelelmiszer,SVGProdIroda,SVGProdKutya,SVGProdMilk,SVGProdSpecFood,SVGProdSutemeny,SVGProdWater,SVGProfileDark,SVGQuestionInCircle,SVGSavedCard,SVGShareField,SVGShare,SVGShipping2,SVGShippingAddress,SVGShippingCar,SVGShippingCarDont,SVGShoppingList,SVGShopsIcon,SVGSmallArrowDown,SVGSocialEmail,SVGSocialFacebook,SVGSocialGetlink,SVGSocialGplus,SVGSocialInstagram,SVGSocialYoutube,SVGStarActive,SVGStarNormal,SVGSupport,SVGTelephoneTiny,SVGThickWhite,SVGTickSuccess,SVGTickTiny,SVGTick,SVGTrashSmall,SVGUserFilled,SVGUser,SVGWait,SVGWithoutGluten,SVGWithoutLactose,SVGWithoutSugar, SVGCalendar }
export default allItems
